/* CE Elevate — global interaction layer ("Brand Elevation").
   Visual/animation only: scroll reveals, hero stagger, decorative
   offer sticker, review count-up, two-tone wordmark. No commerce
   logic, no tracking, no copy changes. Idempotent; safe without JS
   (classes that hide content are only added when this runs) and in
   the theme editor (designMode skips the reveal gate entirely). */
(function () {
  if (window.__ceElevateInit) return;
  window.__ceElevateInit = true;

  var designMode = (window.Shopify && window.Shopify.designMode) ||
    document.documentElement.classList.contains('shopify-design-mode');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  if (!designMode) {
    document.documentElement.classList.add('ce-k-js'); /* keepsake-era reveal gate (home sections) */
    document.documentElement.classList.add('ce-e-js');
  }

  /* Sections whose headers/cards get the scroll reveal (existing markup,
     class assigned at runtime — unknown selectors simply no-op). */
  var REVEAL_TARGETS = [
    '.ce-proof__header',
    '.ce-protection__header', '.ce-protection__card',
    '.ce-hiw__header', '.ce-hiw__step',
    '.ce-lifestyle__header', '.ce-lifestyle__card',
    '.ce-noblur__content', '.ce-noblur__image-wrap', '.ce-noblur__image',
    '.ce-fiveordie__header', '.ce-fiveordie__card',
    '.ce-bogo__content', '.ce-bogo__inner',
    '.ce-social-proof__header', '.ce-social-proof__card',
    '.ce-product-faq__heading', '.ce-product-faq__list',
    '.ce-related-articles__header', '.ce-related-articles__card',
    '.ce-model-hub__title', '.ce-model-hub__brand',
    '.ce-founder__inner', '.ce-founder__content',
    '.ce-seo-content__inner'
  ];

  function initReveals() {
    if (designMode) return;
    var els = [];
    REVEAL_TARGETS.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          if (!el.classList.contains('e-reveal-auto')) { el.classList.add('e-reveal-auto'); }
        });
      } catch (e) { /* bad selector guard */ }
    });
    els = Array.prototype.slice.call(document.querySelectorAll('.e-reveal-auto, .k-reveal, .e-reveal'));
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -70px 0px', threshold: 0.06 });
    els.forEach(function (el) {
      /* anything already in the first viewport shows immediately */
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) {
        el.classList.add('is-in');
      } else {
        io.observe(el);
      }
    });
  }

  /* Hero entrance stagger: rise the hero's top-level columns.
     theme.liquid's inline ce-e-pre gate offsets these parts BEFORE first
     paint so this never yanks already-settled content (the above-fold
     jump). We take over from the gate synchronously — the inline
     transform is set in the same tick the class is removed, so no frame
     renders ungated. If we're running so late that the gate's 2.5s CSS
     safety settle has already fired, skip the stagger: re-offsetting
     settled content would recreate the jump we're preventing.

     TRANSFORM ONLY — never animate opacity or visibility on the hero.
     The hero image is the LCP element; an element that first paints at
     opacity 0 is never recorded as LCP by Chrome (measured: mobile LCP
     fell to the announcement bar text or was missing entirely). A
     transform still paints, so the image counts at first paint. */
  function initHeroStagger() {
    var gateExpired = window.performance && performance.now() > 2400;
    document.documentElement.classList.remove('ce-e-pre');
    if (designMode || reduce || gateExpired) return;
    var parts = document.querySelectorAll(
      '.k-hero .k-hero__content, .k-hero .k-hero__media,' +
      '.ce-hero .ce-hero__content, .ce-hero .ce-hero__media'
    );
    Array.prototype.forEach.call(parts, function (el, i) {
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'transform 0.9s ' + EASE;
      setTimeout(function () {
        el.style.transform = 'none';
        /* clear inline transform so sticky/position logic is unaffected */
        setTimeout(function () { el.style.transform = ''; el.style.transition = ''; }, 1000);
      }, 90 + i * 150);
    });
  }

  /* Decorative BOGO sticker on hero imagery. Echoes the sitewide
     offer already stated in the announcement bar — no new claims.
     Skipped when a host already carries one (idempotent). */
  var STICKER_HOSTS = [
    '.ce-hero .ce-hero__media',
    '.k-hero .k-hero__media'
  ];
  function injectSticker() {
    var host = null, inset = false;
    var caps = 'Buy 1<br>Get 1', script = 'Free';
    for (var i = 0; i < STICKER_HOSTS.length; i++) {
      var el = document.querySelector(STICKER_HOSTS[i]);
      if (el) { host = el; break; }
    }
    /* PDP gallery sticker, ON the photo (22/22 inset) — not straddling
       the container corner like the LP offer sticker. Case PDPs carry
       the lifetime-guarantee sticker (spec); non-case PDPs (the
       combined/individual selector modes) get the BOGO sticker — the
       offer applies sitewide, the guarantee claim is cases-only. */
    if (!host) {
      var pdpHero = document.querySelector('.ce-product-hero');
      if (pdpHero) {
        var nonCasePdp = pdpHero.querySelector('.ce-product-hero__combined-selector') ||
                         pdpHero.querySelector('.ce-product-hero__individual-selector');
        host = pdpHero.querySelector('.ce-product-hero__image-wrap');
        inset = true;
        if (!nonCasePdp) {
          caps = 'Lifetime';
          script = 'guarantee';
        }
      }
    }
    if (!host || host.querySelector('.e-sticker')) return;
    /* No-BOGO surfaces (data-ce-no-bogo, stamped by the hero sections from
       ce_rebrand.bogo_enabled = false): the offer sticker would advertise a
       deal the product cannot honor (the rug family is single-unit only),
       and the guarantee sticker is a cases-only claim. Skip both. */
    if (host.closest('[data-ce-no-bogo]')) return;
    var cs = window.getComputedStyle(host);
    if (cs.position === 'static') { host.style.position = 'relative'; }
    var s = document.createElement('div');
    s.className = 'e-sticker e-sticker--pop';
    s.setAttribute('aria-hidden', 'true');
    s.innerHTML =
      '<span class="e-sticker__caps">' + caps + '</span>' +
      '<span class="e-sticker__script">' + script +
      '<svg viewBox="0 0 60 8" aria-hidden="true"><path d="M2 5.5 C 16 2.5, 32 2, 58 4.5" fill="none" stroke="#1E2529" stroke-width="2" stroke-linecap="round"></path></svg>' +
      '</span>';
    if (script.length > 6) { s.classList.add('e-sticker--long'); }
    s.style.top = inset ? '22px' : '-18px';
    s.style.left = inset ? '22px' : '-14px';
    host.appendChild(s);
    if (designMode || reduce) {
      s.classList.add('is-popped');
    } else {
      setTimeout(function () { s.classList.add('is-popped'); }, 700);
    }
  }

  /* Review count-up: finds the review-count number in the hero rating
     line and counts it up once (1.4s, ease-out, no layout shift). */
  function initCountUp() {
    if (designMode || reduce) return;
    var scope = document.querySelector('.ce-hero__badge, .ce-hero__rating, .ce-product-hero__rating');
    if (!scope || scope.__ceCounted) return;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
    var node = null, match = null;
    while ((node = walker.nextNode())) {
      var m = node.nodeValue && node.nodeValue.match(/(\d{1,3}(?:,\d{3})+|\d{4,})/);
      if (m) { match = { node: node, num: m[1] }; break; }
    }
    if (!match) return;
    scope.__ceCounted = true;
    var target = parseInt(match.num.replace(/,/g, ''), 10);
    if (!target || target < 100) return;
    var span = document.createElement('span');
    span.style.fontVariantNumeric = 'tabular-nums';
    var parts = match.node.nodeValue.split(match.num);
    var after = document.createTextNode(parts.slice(1).join(match.num));
    var before = document.createTextNode(parts[0]);
    var parent = match.node.parentNode;
    parent.replaceChild(after, match.node);
    parent.insertBefore(span, after);
    parent.insertBefore(before, span);
    /* reserve width to avoid layout shift */
    span.textContent = match.num;
    var w = span.getBoundingClientRect().width;
    if (w) { span.style.display = 'inline-block'; span.style.minWidth = Math.ceil(w) + 'px'; }
    var t0 = null, DUR = 1400;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / DUR);
      var eased = 1 - Math.pow(1 - p, 3);
      span.textContent = Math.round(target * eased).toLocaleString('en-US');
      if (p < 1) { requestAnimationFrame(step); }
    }
    requestAnimationFrame(step);
  }

  /* Accent-word system: the design language closes every major heading
     with an Instrument Serif italic coral word. Wrap the LAST word of
     each listed heading (plus trailing punctuation) in a span — pure
     presentation of existing copy, idempotent, designMode-safe. */
  var ACCENT_HEADINGS = [
    '.k-coll__h2', '.k-craft__h2', '.k-steps__h2', '.k-gift__h2',
    '.k-words__head .k-eyebrow',
    '.ce-protection__title', '.ce-hiw__title', '.ce-fiveordie__title',
    '.ce-lifestyle__title', '.ce-noblur__title', '.ce-bogo__title',
    '.ce-product-faq__heading', '.ce-reviews__title',
    '.ce-seo-content__heading', '.ce-model-hub__title',
    '.ce-related-articles__title'
  ];
  function lastTextNode(el) {
    for (var i = el.childNodes.length - 1; i >= 0; i--) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && /\S/.test(n.nodeValue)) return n;
      if (n.nodeType === 1 && !n.classList.contains('e-accent')) {
        var deep = lastTextNode(n);
        if (deep) return deep;
      }
    }
    return null;
  }
  function initAccents() {
    ACCENT_HEADINGS.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (h) {
          if (h.querySelector('.e-accent') || h.querySelector('em')) return;
          var node = lastTextNode(h);
          if (!node) return;
          var m = node.nodeValue.match(/^(.*?)(\S+)(\s*)$/);
          if (!m || !m[2]) return;
          var word = m[2];
          if (word.replace(/[^\w]/g, '').length < 3) return; /* skip tiny fragments */
          var span = document.createElement('span');
          span.className = 'e-accent';
          span.textContent = word;
          var tail = document.createTextNode(m[3] || '');
          node.nodeValue = m[1];
          var parent = node.parentNode;
          var next = node.nextSibling;
          parent.insertBefore(span, next);
          parent.insertBefore(tail, next);
        });
      } catch (e) { /* selector guard */ }
    });
    /* pull trailing punctuation into existing emphasis spans (design colors the period) */
    document.querySelectorAll('.k-hero__h1 em, .k-final__h2 em, .k-gift__h2 em').forEach(function (em) {
      var sib = em.nextSibling;
      if (sib && sib.nodeType === 3) {
        var pm = sib.nodeValue.match(/^([.!?…]+)/);
        if (pm) {
          em.textContent += pm[1];
          sib.nodeValue = sib.nodeValue.slice(pm[1].length);
        }
      }
    });
    /* announcement bar: italicize the trailing clause per the type-pairing language */
    document.querySelectorAll('.announcement-bar__message').forEach(function (msg) {
      if (msg.querySelector('.e-accent-tail')) return;
      var node = lastTextNode(msg);
      if (!node) return;
      var mm = node.nodeValue.match(/^(.*\S)\s+(\S+\s+\S+)\s*$/);
      if (!mm) return;
      var tailSpan = document.createElement('span');
      tailSpan.className = 'e-accent-tail';
      tailSpan.textContent = mm[2];
      node.nodeValue = mm[1] + ' ';
      node.parentNode.insertBefore(tailSpan, node.nextSibling);
    });
    /* Founder quotes: the design accents the emotional peak — the order
       count mid-quote, or the closing phrase (existing copy, styled only) */
    document.querySelectorAll('.ce-founder__quote, .k-founder__quote').forEach(function (q) {
      if (q.querySelector('.e-accent')) return;
      var walker = document.createTreeWalker(q, NodeFilter.SHOW_TEXT, null);
      var node, hit = null;
      while ((node = walker.nextNode())) {
        var m = node.nodeValue.match(/([\d,]{4,}\+?\s+(?:orders|cases))/i);
        if (m) { hit = { node: node, phrase: m[1] }; break; }
      }
      if (hit) {
        var parts = hit.node.nodeValue.split(hit.phrase);
        var span = document.createElement('span');
        span.className = 'e-accent';
        span.textContent = hit.phrase;
        var afterText = document.createTextNode(parts.slice(1).join(hit.phrase));
        var beforeText = document.createTextNode(parts[0]);
        var par = hit.node.parentNode;
        par.replaceChild(afterText, hit.node);
        par.insertBefore(span, afterText);
        par.insertBefore(beforeText, span);
        return;
      }
      /* no count present — accent the closing phrase (last four words) */
      var tail = lastTextNode(q);
      if (!tail) return;
      var tm = tail.nodeValue.match(/^([\s\S]*?)((?:\S+\s+){3}\S+\s*)$/);
      if (!tm) return;
      var span2 = document.createElement('span');
      span2.className = 'e-accent';
      span2.textContent = tm[2].replace(/\s+$/, '');
      tail.nodeValue = tm[1];
      tail.parentNode.appendChild(span2);
    });
    /* How-it-works numerals: index via data attribute (CSS renders "N.") */
    document.querySelectorAll('.ce-hiw__steps').forEach(function (wrap) {
      var i = 0;
      wrap.querySelectorAll('.ce-hiw__step').forEach(function (s) {
        i += 1;
        if (!s.hasAttribute('data-e-num')) s.setAttribute('data-e-num', String(i));
      });
    });
    initStepNums();
  }

  /* PDP step labels: serif-italic coral numeral ("1. Select Your Phone").
     The selector machinery renders these client-side after data load, so
     this runs at init, on short retries, and on the machinery's own
     state-change event (idempotent via the class guard). */
  function initStepNums() {
    document.querySelectorAll('.ce-product-hero__step-label, .ce-product-hero__step-number').forEach(function (label) {
      if (label.querySelector('.e-step-num')) return;
      var node = label.firstChild;
      /* skip leading whitespace-only nodes */
      while (node && node.nodeType === 3 && !/\S/.test(node.nodeValue)) node = node.nextSibling;
      if (!node) return;
      if (node.nodeType === 1) {
        /* numeral already lives in its own element — just adopt it */
        if (/^\s*\d+[.:]?\s*$/.test(node.textContent)) node.classList.add('e-step-num');
        return;
      }
      var nm = node.nodeValue.match(/^(\s*\d+[.:]?)(\s*)/);
      if (!nm) return;
      var span = document.createElement('span');
      span.className = 'e-step-num';
      span.textContent = nm[1].trim();
      node.nodeValue = node.nodeValue.slice(nm[0].length);
      label.insertBefore(document.createTextNode(' '), node);
      label.insertBefore(span, label.firstChild);
    });
  }

  function initCtaPriceSuffix() {
    /* hero CTA price suffix ("… → From $24.99") gets the italic-serif voice */
    document.querySelectorAll('.ce-hero__cta').forEach(function (cta) {
      if (cta.querySelector('.e-cta-price')) return;
      var node = lastTextNode(cta);
      if (!node) return;
      var pm = node.nodeValue.match(/^([\s\S]*?)(From\s+\$[\d.,]+\s*)$/i);
      if (!pm) return;
      var span = document.createElement('span');
      span.className = 'e-cta-price';
      span.textContent = pm[2].trim();
      node.nodeValue = pm[1];
      node.parentNode.insertBefore(span, node.nextSibling);
    });
  }

  /* LP sticky pill: price + promo + button share one row. On narrow
     screens the row can run out of room (long model CTAs like "Design
     My Pro Max Case") — degrade by dropping the promo first, then the
     price line, so the button never truncates or leaves the pill.
     Measured, not guessed: runs after fonts settle and again on resize. */
  function initStickyPromoGuard() {
    var run = function () {
      document.querySelectorAll('.ce-sticky').forEach(function (card) {
        var info = card.querySelector('.ce-sticky__info');
        var promo = card.querySelector('.ce-sticky__promo');
        if (!info) return;
        card.classList.remove('e-promo-tight');
        card.classList.remove('e-title-tight');
        /* the promo flexes down first — any truncation means an ugly
           "★ 4.…" sliver, so it goes entirely */
        if (promo && promo.scrollWidth - promo.clientWidth > 4) {
          card.classList.add('e-promo-tight');
        }
        /* the title never flexes; if it still overflows the info box
           (long model CTAs on narrow screens), it goes too */
        if (info.scrollWidth - info.clientWidth > 4) {
          card.classList.add('e-title-tight');
        }
      });
    };
    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(run, 150);
    });
  }

  /* Proof-gallery photo cycle: the spec trades one grid tile's photo for
     a pooled one every few seconds (fade out → swap → fade in). The pool
     is every photo the section renders but the desktop grid hides — the
     grid shows the first ten and the track also carries marquee clones,
     so the pool is deduped by URL. Displayed photos and the waiting queue
     stay disjoint by construction: a swapped-out photo goes to the back
     of the queue, so the same photo can never sit in two tiles at once.
     Ticks are gated on the ≥900px grid — the mobile strip keeps the
     marquee and never swaps. */
  function initProofCycle() {
    if (designMode || reduce || !window.matchMedia) return;
    var GRID = 10, PERIOD = 3500, FADE = 550;
    var mq = window.matchMedia('(min-width: 900px)');
    document.querySelectorAll('.ce-proof__track').forEach(function (track) {
      if (track.__ceCycle) return;
      var wraps = track.querySelectorAll('.ce-proof__photo');
      if (wraps.length <= GRID) return;
      function attrsOf(img) {
        return {
          src: img.getAttribute('src') || '',
          srcset: img.getAttribute('srcset') || '',
          sizes: img.getAttribute('sizes') || '',
          alt: img.getAttribute('alt') || ''
        };
      }
      var tiles = [], displayed = {}, queue = [];
      for (var i = 0; i < GRID; i++) {
        var img = wraps[i].querySelector('img');
        if (!img || !img.getAttribute('src')) return;
        tiles.push(img);
        displayed[img.getAttribute('src')] = true;
      }
      for (var j = GRID; j < wraps.length; j++) {
        var cand = wraps[j].querySelector('img');
        if (!cand) continue;
        var key = cand.getAttribute('src');
        if (!key || displayed[key]) continue;
        var queued = false;
        for (var q = 0; q < queue.length; q++) {
          if (queue[q].src === key) { queued = true; break; }
        }
        if (!queued) queue.push(attrsOf(cand));
      }
      if (!queue.length) return;
      track.__ceCycle = true;
      var ti = 0, busy = false;
      setInterval(function () {
        if (busy || document.hidden || !mq.matches) return;
        busy = true;
        var tile = tiles[ti % tiles.length];
        ti++;
        var next = queue.shift();
        var pre = new Image();
        pre.onload = function () {
          tile.style.transition = 'opacity 0.55s ease';
          tile.style.opacity = '0';
          setTimeout(function () {
            queue.push(attrsOf(tile));
            if (next.srcset) { tile.setAttribute('srcset', next.srcset); } else { tile.removeAttribute('srcset'); }
            if (next.sizes) { tile.setAttribute('sizes', next.sizes); } else { tile.removeAttribute('sizes'); }
            tile.setAttribute('alt', next.alt);
            tile.setAttribute('src', next.src);
            setTimeout(function () { tile.style.opacity = '1'; busy = false; }, 120);
          }, FADE);
        };
        pre.onerror = function () { queue.push(next); busy = false; };
        if (next.srcset) { pre.srcset = next.srcset; }
        if (next.sizes) { pre.sizes = next.sizes; }
        pre.src = next.src;
      }, PERIOD);
    });
  }

  /* Buy-box protection selector. Chips carry only what varies — photo,
     name, price, the 2nd-case offer, and the drop rating as a pill riding
     on the photo (zero row height). The four USP rows that used to repeat
     on every chip are gone: 18 of those 24 cells were the same string, so
     they cost height and taught nothing. The shared detail now lives in one
     rail under the row that rewrites itself for the selected tier —
     selecting IS the disclosure, so details cost no extra tap.

     MagSafe is PER-TIER and never shared. Basic and Protective genuinely
     have none, so the old shared "Premium MagSafe" row asserted something
     false about them. Elite and Ultimate BOTH have it at $45/10 ft, so
     MagSafe can't separate those two either — the drop rating is the only
     fact that both varies and is true across the ladder, which is exactly
     what the pill carries and nothing else.

     Keyed on DISPLAY name (templates' display_name wins). Cards are
     client-rendered by the frozen machinery — decorate after render,
     idempotent, re-applied on ce:state-change. */
  var TIER_SPEC = {
    'Elite + MagSafe':      { drop: '10 ft drop', rows: [['drop', '10 ft drop-tested'], ['rugged', 'TPU shock absorption'], ['magsafe', 'Built-in MagSafe'], ['print', 'Glossy HD Print']] },
    'Ultimate + MagSafe':   { drop: '10 ft drop', rows: [['drop', '10 ft drop-tested'], ['rugged', 'TPU + TPE shock absorption'], ['magsafe', 'Built-in MagSafe'], ['print', 'Glossy HD Print']] },
    'Protective + MagSafe': { drop: '7 ft drop',  rows: [['drop', '7 ft drop-tested'], ['rugged', 'Dual-layer TPU + hard shell'], ['magsafe', 'Built-in MagSafe'], ['print', 'Glossy HD Print']] },
    'Protective':           { drop: '7 ft drop',  rows: [['drop', '7 ft drop-tested'], ['rugged', 'Dual-layer TPU + hard shell'], ['guarantee', 'Lifetime warranty included'], ['print', 'Glossy HD Print']] },
    'Basic':                { drop: '3 ft drop',  rows: [['drop', '3 ft drop-tested'], ['rugged', 'Slim one-piece TPU'], ['guarantee', 'Lifetime warranty included'], ['print', 'Glossy HD Print']] },
    'Elite Ultra + MagSafe':{ drop: '25 ft drop', rows: [['drop', '25 ft drop-tested'], ['rugged', 'Air-pocket corners'], ['magsafe', 'Built-in MagSafe'], ['print', 'Glossy HD Print']] }
  };

  /* PDP FREE-first pricing (CRO adjudication of the merchant's call):
     prices stay single ("$50" — a clean, spread-out tier ladder), and
     the offer rides as a co-fixated "2nd Case FREE" line in the price
     lockup — FREE does the work "2 for $50" surrendered, with no
     arithmetic path to an imagined $25 single. The under-CTA line
     carries the mechanic + the applied-automatically reassurance.
     Case PDPs only — BOGO is a cases-only claim, and the
     combined/individual selector modes mark non-case products. All
     rewrites are idempotent and re-applied on ce:state-change. */
  function decorateFreePricing() {
    var hero = document.querySelector('.ce-product-hero');
    if (!hero ||
        hero.querySelector('.ce-product-hero__combined-selector') ||
        hero.querySelector('.ce-product-hero__individual-selector')) return;
    /* No-BOGO products (data-ce-no-bogo from ce_rebrand.bogo_enabled =
       false) must never take the FREE-first case pricing, even when the
       selector-mode heuristic reads the PDP as a case (e.g. the AirPods
       Max shell case: single variant, no selector, no BOGO offer). Same
       guard as the offer sticker. */
    if (hero.closest('[data-ce-no-bogo]') || hero.querySelector('[data-ce-no-bogo]')) return;
    hero.querySelectorAll('.ce-product-hero__tier-card-price').forEach(function (el) {
      if (el.nextElementSibling && el.nextElementSibling.classList.contains('e-tier-offer')) return;
      var offer = document.createElement('div');
      offer.className = 'e-tier-offer';
      offer.appendChild(document.createTextNode('2nd Case '));
      var free = document.createElement('b');
      free.className = 'e-tier-offer__free';
      /* the sticker's hand-drawn squiggle, coral — same brand stroke,
         quiet emphasis under the one word doing the work */
      free.innerHTML = 'FREE<svg viewBox="0 0 60 8" aria-hidden="true"><path d="M2 5.5 C 16 2.5, 32 2, 58 4.5" fill="none" stroke="#123F37" stroke-width="2.5" stroke-linecap="round"></path></svg>';
      offer.appendChild(free);
      el.parentNode.insertBefore(offer, el.nextSibling);
    });
    hero.querySelectorAll('[id^="ce-product-hero__cta-"]').forEach(function (btn) {
      var t = btn.textContent;
      if (t.indexOf('·') === -1 && /\s\$[\d.]+\s*$/.test(t)) {
        btn.textContent = t.replace(/\s(\$[\d.]+)(\s*)$/, ' · $1$2');
      }
    });
    hero.querySelectorAll('.ce-product-hero__sub-cta').forEach(function (el) {
      if (el.__ceRewritten) return;
      /* CRO Test #3 treatment line (ce-product-hero, offer_style = card)
         carries its own final copy: leave it alone. */
      if (el.classList.contains('ce-product-hero__sub-cta--offer')) return;
      el.__ceRewritten = true;
      for (var n = el.lastChild, prev; n; n = prev) {
        prev = n.previousSibling;
        if (n.nodeType === 3) { el.removeChild(n); }
      }
      el.appendChild(document.createTextNode(' 2nd Case Free · Applied Automatically'));
    });
    /* Challenger: the finish step is retired — every case starts glossy
       (the skin hides the step; the machinery's own auto-select already
       lands on finishes[0], which the alphabetical sort makes glossy).
       This guard makes the intent explicit: if a finish card ever
       renders un-selected on glossy, click it through the machinery's
       own path so state/variant/events stay canonical. The one way off
       glossy is the shopper's own tap on the rail's finish switch
       (initFinishSwitch), which this guard leaves alone. */
    var glossyCard = hero.querySelector('.ce-product-hero__finish-card[data-finish="glossy"]:not(.active)');
    if (glossyCard && hero.__ceFinishPick !== 'matte') { glossyCard.click(); }
  }

  /* Non-case PDPs (blankets, desk mats — the combined/individual
     selector modes mark them). What happens here:
     - the under-CTA line drops the hardcoded "Lifetime Guarantee"
       (cases-only claim) for the case-style single line
     - option-card offer chips become the case price lockup: "2nd
       Blanket FREE" with the hand-drawn coral squiggle under FREE
     - the CTA price join matches cases ("· $60", not "→ $60")
     - desk-mat size cards restructure into the case tier-card shape
       (name / size / exact price / "2nd Desk Mat FREE" / per-size
       feature bullets); the BOGO banner above the CTA is gone (Matt +
       CRO: the card FREE lines + sub-CTA line carry the offer)
     - blanket size cards take the same tier-card shape (size /
       use-case line / exact price for the chosen material / "2nd
       Blanket FREE"), plus the template's MOST POPULAR badge — the
       machinery's plain-card renderer drops valCfg.badge on the floor
     - the LAST option's cards get a price placeholder from first
       render, so the machinery's downstream re-render (which adds
       .ce-oc-price after a prior option is picked) can't grow the
       card and shift the page */
  var SQUIGGLE = '<svg viewBox="0 0 60 8" aria-hidden="true"><path d="M2 5.5 C 16 2.5, 32 2, 58 4.5" fill="none" stroke="#123F37" stroke-width="2.5" stroke-linecap="round"></path></svg>';
  /* Product-family noun for non-case PDPs — mirrors
     snippets/ce-product-noun.liquid. '' = case (or unrecognized):
     leave the case copy alone. 'case' wins over every other match so
     a case product name can never fall into another family. */
  var NONCASE_NOUNS = [
    ['cutting board', /cutting\s*board/i],
    ['desk mat', /desk\s*mat/i],
    /* Mahjong mat launch 2026-10-16 (the first direct-vendor launch). Mirrored
       in snippets/ce-product-noun.liquid in the SAME position. */
    ['mahjong mat', /mahjong/i],
    /* Baby & Kids wave 2026-09-08. These eight sit ABOVE the generic
       'blanket' and 'towel' matchers ON PURPOSE: "Custom Baby Swaddle
       Blanket" and "Custom Baby Lovey Blanket" would otherwise take the
       fleece-blanket branch (its "2nd Blanket FREE" lockup and its 60" x 80"
       MOST POPULAR size badge), and "Custom Hooded Towels" would inherit the
       beach-towel family. Deliberately NO word-boundary escapes anywhere in
       this block: the 2026-08-16 stocking commit found the socks matcher's
       escapes had degraded to literal backspace bytes, which can never match.
       Mirrored in snippets/ce-product-noun.liquid in the SAME order. */
    ['swaddle blanket', /swaddle/i],
    ['lovey blanket', /lovey/i],
    ['hooded towel', /hooded\s*towel/i],
    ['bodysuit', /bodysuit/i],
    ['beanie', /beanie/i],
    ['crib sheet', /crib\s*sheet/i],
    ['changing pad cover', /changing\s*pad/i],
    ['nursing pillow cover', /nursing\s*pillow/i],
    /* Custom Pillows launch 2026-10-21 (Pic The Gift direct). BELOW the
       nursing pillow cover so it keeps its own branch. Mirrored in
       snippets/ce-product-noun.liquid in the SAME order. Titles: "Custom
       Throw / Lumbar / Outdoor Pillow ..." (handles custom-*-pillows). */
    ['throw pillow', /throw\s*pillow/i],
    ['lumbar pillow', /lumbar\s*pillow/i],
    ['outdoor pillow', /outdoor\s*pillow/i],
    /* Custom Hooded Blanket launch 2026-10-31 (Pic The Gift direct). ABOVE
       the 'blanket' matcher, whose branch paints "2nd Blanket FREE" cards:
       the hooded blanket sells on the shared Buy More Save More ladder, no
       BOGO. Mirrored in snippets/ce-product-noun.liquid in the SAME order.
       Title: "Custom Hooded Blanket ..." (handle custom-hooded-blankets). */
    ['hooded blanket', /hooded\s*blanket/i],
    ['blanket', /blanket/i],
    /* Travel mug relaunch 2026-08-19: must sit ABOVE the tumbler matcher (the
       PDP title carries both nouns). */
    ['travel mug', /travel\s*mug/i], ['tumbler', /tumbler/i],
    ['mug', /mug/i], ['candle', /candle/i], ['journal', /journal/i],
    ['notebook', /notebook/i], ['clock', /clock/i], ['towel', /towel/i],
    ['puzzle', /puzzle/i], ['canvas print', /canvas/i], ['poster', /poster/i],
    ['watch band', /watch\s*band/i], ['ornament', /ornament/i], ['magnet', /magnet/i],
    /* Zip-up hoodie launch 2026-09: must sit ABOVE the hoodie matcher (the
       PDP title carries both nouns). Mirrored in snippets/ce-product-noun.liquid
       in the SAME order. */
    ['zip-up hoodie', /zip[\s-]*up|full[\s-]*zip/i],
    ['hoodie', /hoodie/i], ['sweatshirt', /sweatshirt/i], ['shirt', /shirt/i],
    ['rope cap', /rope\s*cap/i],
    ['pajama pants', /pajama/i],
    ['socks', /\bsocks?\b/i],
    /* Stocking launch 2026-08-16: 'stocking' never contains the substring
       'sock', so the two families cannot cross-capture. (Same commit
       repaired the socks matcher above: its word-boundary escapes had
       degraded to literal backspace bytes, which can never match.) */
    ['stocking', /stocking/i],
    /* Word-bounded so a title like "Rugged Case" can never land here even
       without the /case/i gate above it. Covers "Rug" and "Rugs". */
    ['rug', /\brugs?\b/i],
    /* Pickleball Set (2026-08-12): must sit ABOVE the bag matcher — the PDP
       title ends "...Paddles, Balls, and Bag". */
    ['pickleball set', /pickleball/i],
    /* Custom Bags family (2026-08-06): tote / weekender / bag titles. */
    ['bag', /\b(?:bags?|tote|weekender)\b/i],
    /* Flip flops (2026-11-03): legacy PDP that rode the case fallback. */
    ['flip flops', /flip[\s-]*flops?/i]
  ];
  function nonCaseNoun(title) {
    /* Deliberate exceptions ABOVE the /case/i gate: the AirPods Max shell
       case, the Kindle case and the MacBook case are case nouns whose PDPs
       must not take phone-case copy (no BOGO offer, different claims).
       Mirrors ce-product-noun.liquid. */
    if (/airpods\s*max/i.test(title)) return 'airpods max case';
    if (/kindle/i.test(title)) return 'kindle case';
    if (/macbook/i.test(title)) return 'macbook case';
    /* Tablet Folio (iPad) launch 2026-08-14: case-family noun, no phone-case copy. */
    if (/ipad|tablet\s*folio/i.test(title)) return 'ipad case';
    if (/case/i.test(title)) return '';
    for (var i = 0; i < NONCASE_NOUNS.length; i++) {
      if (NONCASE_NOUNS[i][1].test(title)) return NONCASE_NOUNS[i][0];
    }
    return '';
  }
  function titleCaseNoun(noun) {
    return noun.replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); });
  }
  var DESKMAT_FEATURES = {
    XXL: [['print', 'HD Print'], ['neoprene', '3mm Comfort Neoprene'], ['antislip', 'Anti-Slip Back'], ['sewn', 'Sewn & Printed Edges']],
    XL:  [['print', 'HD Print'], ['neoprene', '3mm Comfort Neoprene'], ['antislip', 'Anti-Slip Back'], ['sewn', 'Sewn Black Edge']],
    L:   [['print', 'HD Print'], ['neoprene', '3mm Comfort Neoprene'], ['antislip', 'Anti-Slip Back'], ['sewn', 'Sewn Black Edge']],
    M:   [['print', 'HD Print'], ['neoprene', '3mm Comfort Neoprene'], ['antislip', 'Anti-Slip Back'], ['sewn', 'Sewn Black Edge']],
    S:   [['print', 'HD Print'], ['sewn', 'Sewn Edge'], ['sewn', 'Black Edging']]
  };
  var BLANKET_SIZE_BADGES = { '60" x 80"': 'MOST POPULAR' };
  /* Cutting-board feature rail rows, keyed by the SHAPE option value —
     facts only (tempered glass / dye-sub print / rubber feet / policy);
     no knife, food-safety, heat, or durability claims. */
  var BOARD_FEATURES = {
    'Rectangle': [['rugged', 'Tempered Glass Build'], ['print', 'Vivid HD Photo Print'], ['antislip', 'Anti-Slip Rubber Feet'], ['guarantee', '30-Day Money-Back Guarantee']],
    'Wine Bottle': [['rugged', 'Tempered Glass Build'], ['print', 'Vivid HD Photo Print'], ['neoprene', 'Whorled Glass Texture'], ['guarantee', '30-Day Money-Back Guarantee']],
    'Round': [['rugged', 'Tempered Glass Build'], ['print', 'Vivid HD Photo Print'], ['antislip', 'Anti-Slip Rubber Feet'], ['guarantee', '30-Day Money-Back Guarantee']]
  };
  /* Rug feature rail rows, keyed by the STYLE option value — facts from the
     approved copy spec only (polyester chenille face, hemmed edges, style-
     specific backing, remake-on-defect); no durability, washability, or
     delivery claims. */
  var RUG_FEATURES = {
    'Area Rug': [['print', 'Vivid HD Photo Print'], ['neoprene', 'Polyester Chenille Face'], ['sewn', 'Hemmed Edges'], ['guarantee', 'Arrives Wrong? We Remake It']],
    'Outdoor Rug': [['print', 'Vivid HD Photo Print'], ['antislip', 'No-Skid Backing'], ['sewn', 'Hemmed Edges'], ['rugged', 'Made For Outdoor Use']],
    'Round Rug': [['print', 'Vivid HD Photo Print'], ['neoprene', 'Textured Face'], ['sewn', 'Hemmed Edges'], ['guarantee', 'Arrives Wrong? We Remake It']]
  };
  /* variant_display metafield, inlined by the section as the hero-config
     JSON — the machinery consumes badge/desc from it; the skin reads
     default/name for the mat rail. Fail-soft: a parse problem just means
     fallback copy, never a broken selector. */
  function matVariantDisplay(hero) {
    if (hero.__ceVD !== undefined) return hero.__ceVD;
    hero.__ceVD = null;
    var sect = hero.closest('[id^="shopify-section-"]') || document;
    var tag = sect.querySelector('script[id^="ce-hero-config-"]');
    if (tag) {
      try { hero.__ceVD = (JSON.parse(tag.textContent) || {}).variantDisplay || null; }
      catch (e) { /* stay null */ }
    }
    return hero.__ceVD;
  }
  /* One rail per mat selector, inserted AFTER the individual-selector
     (the machinery only ever renders INTO that container, so the rail is
     never wiped). Same e-tier-rail classes as the case rail — the skin
     CSS is shared. */
  function initMatRail(hero, matSel, matCards) {
    var active = matSel.querySelector('.ce-product-hero__visual-card.is-selected');
    /* before the default click lands, populate from the badged card so
       the rail never renders empty or shifts */
    for (var i = 0; i < matCards.length && !active; i++) {
      if (matCards[i].querySelector('.ce-product-hero__vc-badge')) active = matCards[i];
    }
    if (!active) active = matCards[0];
    var val = active.getAttribute('data-value') || '';
    var sm = val.match(/^\s*(XXL|XL|L|M|S)\b/);
    var letter = sm && sm[1];
    if (!letter || !DESKMAT_FEATURES[letter]) return;

    var rail = matSel.nextElementSibling;
    if (!rail || !rail.classList.contains('e-tier-rail')) {
      rail = document.createElement('div');
      rail.className = 'e-tier-rail';
      rail.setAttribute('aria-live', 'polite');
      rail.setAttribute('aria-atomic', 'true');
      matSel.insertAdjacentElement('afterend', rail);
    }
    /* the retry ladder + every state change call this; without the guard
       the rail would re-animate on each no-op pass */
    if (rail.__ceTier === val) return;
    rail.__ceTier = val;

    var vd = matVariantDisplay(hero);
    var vCfg = (vd && vd.option1 && vd.option1.values && vd.option1.values[val]) || {};
    var dims = vCfg.desc || (val.match(/\(([^)]+)\)/) || [])[1] || '';
    var headText = (vCfg.name || letter) + (dims ? ' — ' + dims : '');

    var base = elevateAssetBase();
    rail.innerHTML = '';
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = headText + ' includes';
    rail.appendChild(sr);

    var head = document.createElement('div');
    head.className = 'e-tier-rail__head';
    var nm = document.createElement('span');
    nm.className = 'e-tier-rail__name';
    nm.textContent = headText;
    head.appendChild(nm);
    var spectrum = document.querySelector('.ce-protection');
    if (spectrum) {
      var cmp = document.createElement('button');
      cmp.type = 'button';
      cmp.className = 'e-tier-rail__compare';
      cmp.textContent = 'Compare all sizes →';
      cmp.addEventListener('click', function () {
        spectrum.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      head.appendChild(cmp);
    }
    rail.appendChild(head);

    var ul = document.createElement('ul');
    ul.className = 'e-tier-rail__items';
    DESKMAT_FEATURES[letter].forEach(function (row, ri) {
      var li = document.createElement('li');
      li.style.setProperty('--e-rail-i', ri);
      var icon = document.createElement('img');
      icon.className = 'e-tier-rail__icon';
      icon.src = base + 'icon-usp-' + row[0] + '.png';
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');
      icon.width = 12;
      icon.height = 12;
      icon.loading = 'lazy';
      li.appendChild(icon);
      var label = document.createElement('span');
      label.className = 'e-tier-rail__label';
      label.textContent = row[1];
      li.appendChild(label);
      ul.appendChild(li);
    });
    rail.appendChild(ul);

    /* animate in only — fading out first would cost a round-trip and
       read as lag on tap */
    rail.classList.remove('is-in');
    requestAnimationFrame(function () { rail.classList.add('is-in'); });
  }
  /* Cutting-board rail — same e-tier-rail chrome as the mat rail, but
     keyed by the full SIZE option value (board sizes have no XXL-style
     letter prefix). One rail under the size cards, rewritten per
     selection; the compare link is omitted until a compare target
     section exists on the board PDP. */
  function initBoardRail(hero, boardSel, boardCards) {
    var active = boardSel.querySelector('.ce-product-hero__visual-card.is-selected') || boardCards[0];
    if (!active) return;
    var val = active.getAttribute('data-value') || '';
    if (!BOARD_FEATURES[val]) return;

    var rail = boardSel.nextElementSibling;
    if (!rail || !rail.classList.contains('e-tier-rail')) {
      rail = document.createElement('div');
      rail.className = 'e-tier-rail';
      rail.setAttribute('aria-live', 'polite');
      rail.setAttribute('aria-atomic', 'true');
      boardSel.insertAdjacentElement('afterend', rail);
    }
    if (rail.__ceTier === val) return;
    rail.__ceTier = val;

    var vd = matVariantDisplay(hero);
    var vCfg = (vd && vd.option1 && vd.option1.values && vd.option1.values[val]) || {};
    var headText = (vCfg.name || val) + (vCfg.desc ? ' — ' + vCfg.desc : '');

    var base = elevateAssetBase();
    rail.innerHTML = '';
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = headText + ' includes';
    rail.appendChild(sr);

    var head = document.createElement('div');
    head.className = 'e-tier-rail__head';
    var nm = document.createElement('span');
    nm.className = 'e-tier-rail__name';
    nm.textContent = headText;
    head.appendChild(nm);
    rail.appendChild(head);

    var ul = document.createElement('ul');
    ul.className = 'e-tier-rail__items';
    BOARD_FEATURES[val].forEach(function (row, ri) {
      var li = document.createElement('li');
      li.style.setProperty('--e-rail-i', ri);
      var icon = document.createElement('img');
      icon.className = 'e-tier-rail__icon';
      icon.src = base + 'icon-usp-' + row[0] + '.png';
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');
      icon.width = 12;
      icon.height = 12;
      icon.loading = 'lazy';
      li.appendChild(icon);
      var label = document.createElement('span');
      label.className = 'e-tier-rail__label';
      label.textContent = row[1];
      li.appendChild(label);
      ul.appendChild(li);
    });
    rail.appendChild(ul);

    rail.classList.remove('is-in');
    requestAnimationFrame(function () { rail.classList.add('is-in'); });
  }
  /* Individual-mode PDPs inline their product server-side, so the
     decorator has no global to read variant prices from. Fetch the
     same /products/<handle>.js the case machinery uses (one tiny
     request, non-case PDPs only) and re-decorate when it lands. */
  var NONCASE_PRODUCT = { requested: false, data: null };
  function fetchNonCaseProduct() {
    if (NONCASE_PRODUCT.requested) return;
    /* canonical first — preview/proxy URLs don't always carry the
       /products/<handle> path */
    var canonical = document.querySelector('link[rel="canonical"]');
    var m = ((canonical && canonical.href) || location.pathname).match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    NONCASE_PRODUCT.requested = true;
    fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        /* Shopify's legacy /products/*.js caps at 250 variants (shirt hit
           307 on 2026-08-11 and the last 7 colors rendered struck). The
           hero config's "variants" carries the FULL ce_rebrand.variant_matrix
           serialization when stamped -- prefer it whenever it is fuller. */
        try {
          var vmTag = document.querySelector('script[id^="ce-hero-config-"]');
          if (vmTag) {
            var vmVars = ((JSON.parse(vmTag.textContent) || {}).currentProduct || {}).variants || [];
            if (vmVars.length > (p.variants || []).length) p.variants = vmVars;
          }
        } catch (e) { /* keep the fetched list */ }
        NONCASE_PRODUCT.data = p;
        decorateNonCaseOffer();
      })
      .catch(function () { /* cards keep their reserved price slots */ });
  }
  /* Rug rail — same e-tier-rail chrome, keyed by the full STYLE option value
     (RUG_FEATURES). The compare link targets the size spectrum section the
     launch-rug template carries ("Which size is right for you?"). */
  function initRugRail(hero, rugSel, rugCards) {
    var active = rugSel.querySelector('.ce-product-hero__visual-card.is-selected') || rugCards[0];
    if (!active) return;
    var val = active.getAttribute('data-value') || '';
    if (!RUG_FEATURES[val]) return;

    var rail = rugSel.nextElementSibling;
    if (!rail || !rail.classList.contains('e-tier-rail')) {
      rail = document.createElement('div');
      rail.className = 'e-tier-rail';
      rail.setAttribute('aria-live', 'polite');
      rail.setAttribute('aria-atomic', 'true');
      rugSel.insertAdjacentElement('afterend', rail);
    }
    if (rail.__ceTier === val) return;
    rail.__ceTier = val;

    var vd = matVariantDisplay(hero);
    var vCfg = (vd && vd.option1 && vd.option1.values && vd.option1.values[val]) || {};
    var headText = (vCfg.name || val) + (vCfg.desc ? ' — ' + vCfg.desc : '');

    var base = elevateAssetBase();
    rail.innerHTML = '';
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = headText + ' includes';
    rail.appendChild(sr);

    var head = document.createElement('div');
    head.className = 'e-tier-rail__head';
    var nm = document.createElement('span');
    nm.className = 'e-tier-rail__name';
    nm.textContent = headText;
    head.appendChild(nm);
    var spectrum = document.querySelector('.ce-protection');
    if (spectrum) {
      var cmp = document.createElement('button');
      cmp.type = 'button';
      cmp.className = 'e-tier-rail__compare';
      cmp.textContent = 'Compare all sizes →';
      cmp.addEventListener('click', function () {
        spectrum.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      head.appendChild(cmp);
    }
    rail.appendChild(head);

    var ul = document.createElement('ul');
    ul.className = 'e-tier-rail__items';
    RUG_FEATURES[val].forEach(function (row, ri) {
      var li = document.createElement('li');
      li.style.setProperty('--e-rail-i', ri);
      var icon = document.createElement('img');
      icon.className = 'e-tier-rail__icon';
      icon.src = base + 'icon-usp-' + row[0] + '.png';
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');
      icon.width = 12;
      icon.height = 12;
      icon.loading = 'lazy';
      li.appendChild(icon);
      var label = document.createElement('span');
      label.className = 'e-tier-rail__label';
      label.textContent = row[1];
      li.appendChild(label);
      ul.appendChild(li);
    });
    rail.appendChild(ul);

    rail.classList.remove('is-in');
    requestAnimationFrame(function () { rail.classList.add('is-in'); });
  }
  /* Mahjong mat feature rail (founder ask 2026-10-16: the desk mat's size
     rail under the size cards). Keyed by the SIZE option value. Facts only
     from the launch claims gate: neoprene + thickness, edge-to-edge print,
     rubber backing (NOT "anti-slip": performance claims are held for this
     family), sewn edge printed with the design, the bag on the bag size. */
  var MAHJONG_FEATURES = {
    '31.5"': { head: '31.5" Full Size \u00b7 31.5 \u00d7 31.5 in', rows: [['print', 'Edge-to-Edge HD Print'], ['neoprene', '3mm Neoprene'], ['antislip', 'Rubber Backing'], ['sewn', 'Sewn & Printed Edges']] },
    '31.5" with carrying bag': { head: '31.5" with Carrying Bag \u00b7 31.5 \u00d7 31.5 in', rows: [['print', 'Edge-to-Edge HD Print'], ['neoprene', '3mm Neoprene'], ['sewn', 'Sewn & Printed Edges'], ['rugged', 'Carrying Bag Included']] },
    '20.9" travel': { head: '20.9" Travel \u00b7 20.9 \u00d7 20.9 in', rows: [['print', 'Edge-to-Edge HD Print'], ['neoprene', '2mm Neoprene'], ['antislip', 'Rubber Backing'], ['sewn', 'Sewn & Printed Edges']] }
  };
  /* Same e-tier-rail chrome as the desk mat / rug rails, inserted after the
     individual selector (compact option cards). "Compare all sizes" scrolls
     to the PDP's size section (the seo block headed "Which mahjong mat size
     is right for you?"); absent that section, no link. */
  function initMahjongRail(hero, selEl) {
    var active = selEl.querySelector('.ce-product-hero__option-card.is-selected[data-option-key="option1"]');
    if (!active) return;
    var val = active.getAttribute('data-value') || '';
    var cfg = MAHJONG_FEATURES[val];
    if (!cfg) return;

    var rail = selEl.nextElementSibling;
    if (!rail || !rail.classList.contains('e-tier-rail')) {
      rail = document.createElement('div');
      rail.className = 'e-tier-rail';
      rail.setAttribute('aria-live', 'polite');
      rail.setAttribute('aria-atomic', 'true');
      selEl.insertAdjacentElement('afterend', rail);
    }
    if (rail.__ceTier === val) return;
    rail.__ceTier = val;

    var base = elevateAssetBase();
    rail.innerHTML = '';
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = cfg.head + ' includes';
    rail.appendChild(sr);

    var head = document.createElement('div');
    head.className = 'e-tier-rail__head';
    var nm = document.createElement('span');
    nm.className = 'e-tier-rail__name';
    nm.textContent = cfg.head;
    head.appendChild(nm);
    var sizeSection = null;
    document.querySelectorAll('h2, h3').forEach(function (h) {
      if (!sizeSection && /which mahjong mat size/i.test(h.textContent)) sizeSection = h;
    });
    if (sizeSection) {
      var cmp = document.createElement('button');
      cmp.type = 'button';
      cmp.className = 'e-tier-rail__compare';
      cmp.textContent = 'Compare all sizes \u2192';
      cmp.addEventListener('click', function () {
        sizeSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      head.appendChild(cmp);
    }
    rail.appendChild(head);

    var ul = document.createElement('ul');
    ul.className = 'e-tier-rail__items';
    cfg.rows.forEach(function (row, ri) {
      var li = document.createElement('li');
      li.style.setProperty('--e-rail-i', ri);
      var icon = document.createElement('img');
      icon.className = 'e-tier-rail__icon';
      icon.src = base + 'icon-usp-' + row[0] + '.png';
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');
      icon.width = 12;
      icon.height = 12;
      icon.loading = 'lazy';
      li.appendChild(icon);
      var label = document.createElement('span');
      label.className = 'e-tier-rail__label';
      label.textContent = row[1];
      li.appendChild(label);
      ul.appendChild(li);
    });
    rail.appendChild(ul);

    rail.classList.remove('is-in');
    requestAnimationFrame(function () { rail.classList.add('is-in'); });
  }
  /* Airpods max case features (facts only: sublimation print, polycarbonate
     shell, made-right guarantee — no drop/impact or delivery claims). */
  var AIRPODS_FEATURES = {
    'Custom': [['print', 'Vivid Full-Wrap Sublimation Print'], ['rugged', 'Lightweight Polycarbonate Shell'], ['guarantee', 'Scratch Protection Built In']]
  };
  /* Kindle case features (facts only, from the fulfilling vendor's catalog:
     UV-printed Saffiano leatherette across all three models, plus the folio
     family's TPU cradle and magnetic sleep/wake lid — no drop/impact or
     delivery claims). Keyed 'default' so the SAME rail serves every model
     card: the 2026-07-28 option-value rename to model names silently killed
     a value-keyed lookup ('Custom') and the rail vanished — never key rails
     to renameable option values again. */
  var KINDLE_FEATURES = {
    'default': [['print', 'UV-Printed Saffiano Texture'], ['rugged', 'Soft TPU Shell Inside'], ['magsafe', 'Magnetic Sleep/Wake Lid']]
  };
  /* MacBook case features. Every string is lifted from the APPROVED launch
     copy spec (single UV-printed front surface on a matte shell, tool-free
     snap-on install, ports and buttons stay reachable) — no drop/impact,
     material-weight or delivery claims, and nothing about the print film
     that the spec attributes to the printable layer rather than the shell.
     Keyed 'default' so the SAME rail serves all five model cards (the
     kindle lesson: never key a rail to renameable option values). */
  var MACBOOK_FEATURES = {
    'default': [['print', 'UV-Printed Matte Finish'], ['magsafe', 'Tool-Free Snap-On Fit'], ['guarantee', 'Ports & Buttons Accessible']]
  };
  /* iPad folio features. Facts from the vendor blueprint prose bound into
     the approved copy spec (PU vegan leather wallet folio, five interior
     pockets, built-in stand, precision-cut ports) — no care, durability or
     delivery claims. Keyed 'default' so the SAME rail serves all eight
     model cards (never key a rail to renameable option values). */
  var IPAD_FEATURES = {
    'default': [['print', 'UV-Printed Satin Cover'], ['rugged', 'Wallet Folio + Stand'], ['guarantee', 'Ports & Camera Accessible']]
  };
  /* "Help me find my model" (iPad folio buy box, 2026-09-23). Every iPad
     Apple lists on its "Identify your iPad model" page (support.apple.com
     108043, pulled 2026-09-23), newest first within each line, as
     [Model Name as iPadOS shows it in Settings > General > About, year,
      A-numbers, vendor size id, extra search words].
     The vendor size id is the tail of the variant SKU
     (CE-tablet-folio-case-<id>), so a renamed card value never breaks a
     match (kindle lesson). 0 = no folio fits that iPad.
     Fit basis: the vendor's own size labels (mini A17 Pro; Air 11 M3/M2/5th/
     4th; Air 13 M3/M2; iPad A16/10th; Pro 11 M4; Pro 13 M4) and its note
     that the Pro 11 size fits the 2nd and 3rd gen and the Pro 12.9 size the
     4th and 5th gen. Same-body siblings ride along: mini 6th gen (= A17 Pro),
     Pro 11 1st + 4th gen, Pro 12.9 3rd + 6th gen (the cards already say
     2018-2022), Pro M5 (= M4) and Air M4 (= M3/M2; Apple sells one Smart
     Folio across each pair). When Apple ships a new iPad, add a row here. */
  var IPAD_MODELS = [
    ['iPad Pro 13-inch (M5)', 2025, 'A3360 A3361 A3362', 244214, ''],
    ['iPad Pro 11-inch (M5)', 2025, 'A3357 A3358 A3359', 244213, ''],
    ['iPad Pro 13-inch (M4)', 2024, 'A2925 A2926 A3007', 244214, ''],
    ['iPad Pro 11-inch (M4)', 2024, 'A2836 A2837 A3006', 244213, ''],
    ['iPad Pro 12.9-inch (6th generation)', 2022, 'A2436 A2437 A2764 A2766', 111493, 'm2'],
    ['iPad Pro 11-inch (4th generation)', 2022, 'A2759 A2761 A2435 A2762', 111492, 'm2'],
    ['iPad Pro 12.9-inch (5th generation)', 2021, 'A2378 A2461 A2379 A2462', 111493, 'm1'],
    ['iPad Pro 11-inch (3rd generation)', 2021, 'A2377 A2459 A2301 A2460', 111492, 'm1'],
    ['iPad Pro 12.9-inch (4th generation)', 2020, 'A2229 A2069 A2232 A2233', 111493, ''],
    ['iPad Pro 11-inch (2nd generation)', 2020, 'A2228 A2068 A2230 A2231', 111492, ''],
    ['iPad Pro 12.9-inch (3rd generation)', 2018, 'A1876 A2014 A1895 A1983', 111493, ''],
    ['iPad Pro 11-inch', 2018, 'A1980 A2013 A1934 A1979', 111492, '1st generation'],
    ['iPad Pro 12.9-inch (2nd generation)', 2017, 'A1670 A1671 A1821', 0, ''],
    ['iPad Pro (10.5-inch)', 2017, 'A1701 A1709 A1852', 0, ''],
    ['iPad Pro (9.7-inch)', 2016, 'A1673 A1674 A1675', 0, ''],
    ['iPad Pro (12.9-inch)', 2015, 'A1584 A1652', 0, '1st generation'],
    ['iPad Air 13-inch (M4)', 2026, 'A3461 A3462 A3464', 244216, ''],
    ['iPad Air 11-inch (M4)', 2026, 'A3459 A3460 A3463', 244215, ''],
    ['iPad Air 13-inch (M3)', 2025, 'A3268 A3269 A3271', 244216, ''],
    ['iPad Air 11-inch (M3)', 2025, 'A3266 A3267 A3270', 244215, ''],
    ['iPad Air 13-inch (M2)', 2024, 'A2898 A2899 A2900', 244216, '6th generation'],
    ['iPad Air 11-inch (M2)', 2024, 'A2902 A2903 A2904', 244215, '6th generation'],
    ['iPad Air (5th generation)', 2022, 'A2588 A2589 A2591', 244215, '10.9-inch m1'],
    ['iPad Air (4th generation)', 2020, 'A2316 A2324 A2325 A2072', 244215, '10.9-inch'],
    ['iPad Air (3rd generation)', 2019, 'A2152 A2123 A2153 A2154', 0, '10.5-inch'],
    ['iPad Air 2', 2014, 'A1566 A1567', 0, '2nd generation 9.7-inch'],
    ['iPad Air', 2013, 'A1474 A1475 A1476', 0, '1st generation 9.7-inch'],
    ['iPad mini (A17 Pro)', 2024, 'A2993 A2995 A2996', 244217, '7th generation 8.3-inch'],
    ['iPad mini (6th generation)', 2021, 'A2567 A2568 A2569', 244217, '8.3-inch'],
    ['iPad mini (5th generation)', 2019, 'A2133 A2124 A2126 A2125', 0, '7.9-inch'],
    ['iPad mini 4', 2015, 'A1538 A1550', 0, '4th generation 7.9-inch'],
    ['iPad mini 3', 2014, 'A1599 A1600', 0, '3rd generation 7.9-inch'],
    ['iPad mini 2', 2013, 'A1489 A1490 A1491', 0, '2nd generation 7.9-inch'],
    ['iPad mini', 2012, 'A1432 A1454 A1455', 0, '1st generation 7.9-inch'],
    ['iPad (A16)', 2025, 'A3354 A3355 A3356', 244218, '11th generation 11-inch'],
    ['iPad (10th generation)', 2022, 'A2696 A2757 A2777 A3162', 244218, '10.9-inch'],
    ['iPad (9th generation)', 2021, 'A2602 A2604 A2603 A2605', 0, '10.2-inch'],
    ['iPad (8th generation)', 2020, 'A2270 A2428 A2429 A2430', 0, '10.2-inch'],
    ['iPad (7th generation)', 2019, 'A2197 A2200 A2198', 0, '10.2-inch'],
    ['iPad (6th generation)', 2018, 'A1893 A1954', 0, '9.7-inch'],
    ['iPad (5th generation)', 2017, 'A1822 A1823', 0, '9.7-inch'],
    ['iPad (4th generation)', 2012, 'A1458 A1459 A1460', 0, '9.7-inch'],
    ['iPad (3rd generation)', 2012, 'A1416 A1430 A1403', 0, '9.7-inch'],
    ['iPad 2', 2011, 'A1395 A1396 A1397', 0, '2nd generation 9.7-inch'],
    ['iPad', 2010, 'A1219 A1337', 0, '1st generation original 9.7-inch']
  ];
  /* Rope cap features. Every string is lifted from the vendor's blueprint
     facts bound into the approved copy spec (polyester micro ripstop,
     adjustable plastic snapback, curved bill with rope braid) — no care,
     durability or delivery claims. Keyed 'default' so the SAME rail serves
     all eight color cards (never key a rail to renameable option values). */
  var CAP_FEATURES = {
    'default': [['print', 'DTF-Printed Front Panel'], ['rugged', 'Micro Ripstop Weave'], ['magsafe', 'Adjustable Snapback']]
  };
  /* Watch band features rail (relaunch 2026-09-01). Facts only, from the
     approved product truth (edge-to-edge sublimation on the faux leather
     strap, suede lining, 30-day money-back). Keyed 'default': the size
     values are words that could be renamed, and a value-keyed rail dies
     silently on a rename (kindle lesson). */
  var WATCH_FEATURES = {
    'default': [['print', 'Edge-to-Edge Sublimation Print'], ['sewn', 'Faux Leather, Suede Lined'], ['guarantee', '30-Day Money-Back Guarantee']]
  };
  /* Pajama pants features rail — keyed 'default' on purpose (a size-value
     rename can never kill a value-keyed rail; kindle lesson). Facts from the
     approved copy spec/vendor prose only. */
  var PJ_FEATURES = {
    'default': [['print', 'All-Over HD Print'], ['neoprene', 'Soft Brushed Polyester'], ['sewn', 'Elastic Waistband'], ['guarantee', 'Arrives Wrong? We Make It Right']]
  };
  /* Shirt features rail — keyed 'default' on purpose (a value rename can
     never kill a value-keyed rail; kindle lesson). Facts from the approved
     copy spec/vendor prose only: DTG print, Airlume combed ring-spun cotton,
     front+back print areas, make-it-right guarantee. */
  var SHIRT_FEATURES = {
    'default': [['print', 'Printed Into the Fabric'], ['neoprene', 'Combed Ring-Spun Cotton'], ['sewn', 'Front + Back Printable'], ['guarantee', 'Arrives Wrong? We Make It Right']]
  };
  /* ===== Baby & Kids wave feature rails (2026-09-08) =====
     Every row states ONE of exactly five permitted facts and nothing else:
     printed to order, your photo or name, which print areas exist, whether
     the print runs edge to edge, and "Preview Before You Buy". No safety,
     sleep, fit, material, warmth, care, delivery, gift-packaging or offer
     claims live on a baby rail, and no vendor or brand name appears in one.
     Prices never appear here: the buy box reads them from the product.
     All keyed 'default' so a size/style value rename can never kill a rail
     (the kindle lesson). */
  var BODYSUIT_FEATURES = {
    'default': [['print', 'Printed to Order'], ['sewn', 'Front + Back Printable'], ['neoprene', 'Your Photo or Name'], ['guarantee', 'Preview Before You Buy']]
  };
  /* The long-legged one-piece prints the FRONT only — never inherit the
     snap bodysuit's front+back row. */
  var BODYSUIT_LONG_FEATURES = {
    'default': [['print', 'Printed to Order'], ['sewn', 'Full Front Print Area'], ['neoprene', 'Your Photo or Name'], ['guarantee', 'Preview Before You Buy']]
  };
  var BEANIE_FEATURES = {
    'default': [['print', 'All-Over Print, Front + Back'], ['neoprene', 'Your Photo or Name'], ['sewn', 'Printed to Order'], ['guarantee', 'Preview Before You Buy']]
  };
  var SWADDLE_FEATURES = {
    'default': [['print', 'Edge-to-Edge Print'], ['neoprene', 'Your Photo or Name'], ['sewn', 'Printed to Order'], ['guarantee', 'Preview Before You Buy']]
  };
  var LOVEY_FEATURES = {
    'default': [['print', 'Edge-to-Edge Print'], ['sewn', 'Front + Back Printable'], ['neoprene', 'Your Photo or Name'], ['guarantee', 'Preview Before You Buy']]
  };
  var CRIB_SHEET_FEATURES = {
    'default': [['print', 'Edge-to-Edge Print'], ['neoprene', 'Your Photo or Name'], ['sewn', 'Printed to Order'], ['guarantee', 'Preview Before You Buy']]
  };
  var CHANGING_PAD_FEATURES = {
    'default': [['print', 'Edge-to-Edge Print'], ['neoprene', 'Your Photo or Name'], ['sewn', 'Printed to Order'], ['guarantee', 'Preview Before You Buy']]
  };
  var NURSING_PILLOW_FEATURES = {
    'default': [['print', 'Edge-to-Edge Print'], ['sewn', 'Front + Back Printable'], ['neoprene', 'Your Photo or Name'], ['guarantee', 'Preview Before You Buy']]
  };
  var HOODED_TOWEL_FEATURES = {
    'default': [['print', 'Printed to Order'], ['neoprene', 'Your Photo or Name'], ['sewn', 'Two Sizes to Choose From'], ['guarantee', 'Preview Before You Buy']]
  };
  /* Baby & Kids single-axis buy box (2026-09-08). Six of the wave's nouns
     sell in ONE size and the hooded towel sells in two styles, so all seven
     take the airpods-max shape: default-select the variant_display default
     (first card as the fallback) so the CTA is never stuck on "Choose Style
     to Continue", title each card from variant_display, drop the "From "
     prefix (one variant per card means the card price IS the price), and
     hang the noun's feature rail under the selector. Every price on screen
     is the one the theme already rendered from the product; nothing here
     hardcodes or recomputes one. `flag` scopes the one-shot default click
     per noun so two nouns can never share a latch. */
  function initBabySingleAxis(hero, features, flag) {
    hero.classList.add('e-mat-hero');
    hero.classList.add('e-board-hero');
    hero.classList.add('e-am-hero');
    var bySel = hero.querySelector('.ce-product-hero__individual-selector');
    var byCards = bySel
      ? bySel.querySelectorAll(
          '.ce-product-hero__visual-card[data-option-key="option1"], .ce-product-hero__option-swatch[data-option-key="option1"]'
        )
      : [];
    if (!byCards.length) return;
    var byVd = matVariantDisplay(hero);
    if (!hero[flag] && !bySel.querySelector('.ce-product-hero__visual-card.is-selected, .ce-product-hero__option-swatch.is-selected')) {
      hero[flag] = true;
      var byDefVal = byVd && byVd.option1 && byVd.option1['default'];
      var byDefCard = null;
      for (var bi = 0; bi < byCards.length && !byDefCard; bi++) {
        if (byDefVal && byCards[bi].getAttribute('data-value') === byDefVal) byDefCard = byCards[bi];
      }
      if (!byDefCard) byDefCard = byCards[0];
      if (byDefCard) byDefCard.click();
    }
    /* Sparse Style x Size sync (hooded towel: each style sells ONE size).
       Same value-idempotent click path as the canvas/rug branches: when the
       selected size is not sold in the selected style, click the first size
       that is, so a style tap never lands on "Sold Out"; sizes the chosen
       style never sells are hidden (a visible dead card reads as broken). */
    var bySizeCards = bySel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]');
    if (bySizeCards.length) {
      hero.classList.add('e-sparse-axes');
      fetchNonCaseProduct();
      var bySyncSizes = function () {
        var byStyleCard = bySel.querySelector('.ce-product-hero__visual-card.is-selected[data-option-key="option1"]');
        var byStyleVal = byStyleCard && byStyleCard.getAttribute('data-value');
        var byProd = NONCASE_PRODUCT.data;
        if (!byStyleVal || !byProd) return;
        var byValidSizes = [];
        (byProd.variants || []).forEach(function (v) {
          if (v.option1 === byStyleVal && v.available !== false && byValidSizes.indexOf(v.option2) === -1) byValidSizes.push(v.option2);
        });
        if (byValidSizes.length) {
          var bySelectedSize = null, bySizeCardByValue = {};
          bySizeCards.forEach(function (card) {
            var val = card.getAttribute('data-value');
            bySizeCardByValue[val] = card;
            if (card.classList.contains('is-selected')) bySelectedSize = val;
            card.style.display = byValidSizes.indexOf(val) === -1 ? 'none' : '';
          });
          if ((!bySelectedSize || byValidSizes.indexOf(bySelectedSize) === -1) && bySizeCardByValue[byValidSizes[0]]) {
            bySizeCardByValue[byValidSizes[0]].click();
          }
        }
        /* A style that sells ANY size stays tappable. The hero grades a style
           against the CURRENT size (Kids x 30" x 30" has no variant), and its
           .is-unavailable rule kills pointer events, so the Kids card was dead
           on the live PDP (founder report 2026-09-09). Relax option1 to "any
           available variant"; the size sync above makes the tap land. */
        byCards.forEach(function (card) {
          var byCardVal = card.getAttribute('data-value');
          var byAny = (byProd.variants || []).some(function (v) { return v.option1 === byCardVal && v.available !== false; });
          if (byAny) card.classList.remove('is-unavailable');
        });
      };
      bySyncSizes();
      /* The hero re-grades on every card click (its listener registered first),
         so re-sync after it: style tap -> matching size -> relaxed styles. */
      var byBindSync = function (card) {
        if (card.__ceSparseBound) return;
        card.__ceSparseBound = true;
        card.addEventListener('click', function () { setTimeout(bySyncSizes, 0); });
      };
      byCards.forEach(byBindSync);
      bySizeCards.forEach(byBindSync);
    }
    byCards.forEach(function (card) {
      /* Swatch buttons ARE the chip — no name/desc injection. */
      if (card.classList.contains('ce-product-hero__option-swatch')) return;
      var byVal = card.getAttribute('data-value') || '';
      var byCfg = (byVd && byVd.option1 && byVd.option1.values && byVd.option1.values[byVal]) || {};
      var byNameEl = card.querySelector('.ce-product-hero__vc-name');
      if (byNameEl && byCfg.name && byNameEl.textContent !== byCfg.name) {
        byNameEl.textContent = byCfg.name;
      }
      if (byCfg.desc) {
        var byDescEl = card.querySelector('.ce-product-hero__vc-desc');
        if (!byDescEl) {
          byDescEl = document.createElement('div');
          byDescEl.className = 'ce-product-hero__vc-desc';
          if (byNameEl) byNameEl.insertAdjacentElement('afterend', byDescEl);
          else card.appendChild(byDescEl);
        }
        if (byDescEl.textContent !== byCfg.desc) byDescEl.textContent = byCfg.desc;
      }
      var byPriceEl = card.querySelector('.ce-product-hero__vc-price');
      if (byPriceEl) {
        byPriceEl.textContent = byPriceEl.textContent.replace(/^\s*From\s+/i, '');
      }
    });
    initAmRail(hero, bySel, byCards, features);
  }
  /* Mug features rails (custom mugs relaunch 2026-08-09) — keyed 'default'
     (value renames can never kill a value-keyed rail; kindle lesson). Facts
     from the vendor blueprints via the approved launch copy: classic ceramic
     is dishwasher/microwave safe + lead & BPA free; the accent mug has NO
     dishwasher/microwave claim (colored interior + matching handle, glossy
     lead & BPA free ceramic); the morph mug is heat-reactive and HAND WASH
     RECOMMENDED (never dishwasher/microwave-safe). */
  var MUG_CERAMIC_FEATURES = {
    'default': [['print', 'Vivid Wrap-Around Print'], ['guarantee', 'Dishwasher & Microwave Safe'], ['rugged', 'Lead & BPA Free Ceramic']]
  };
  var MUG_ACCENT_FEATURES = {
    'default': [['print', 'Vivid Wrap-Around Print'], ['neoprene', 'Colored Interior & Handle'], ['rugged', 'Glossy Ceramic, Lead & BPA Free']]
  };
  var MUG_MORPH_FEATURES = {
    'default': [['print', 'Heat-Reactive Photo Reveal'], ['rugged', 'Solid Black Until Hot'], ['guarantee', 'Hand Washing Recommended']]
  };
  /* Mug color swatch dots. Ceramic sells Style [White, Black]; the accent
     mug sells Color [8 interior/handle colors] — hexes sampled from each
     colorway's own calibrated vendor photo (rim-interior band, 2026-08-09),
     lightened where interior shadow darkened the sample. Keyed by option
     VALUE — a value rename must update this map alongside variant_display. */
  var MUG_SWATCHES = {
    'White': '#F5F5F3',
    'Black': '#1A1A1C',
    'Navy': '#232A52',
    'Pink': '#F2B3AF',
    'Red': '#C73522',
    'Light Blue': '#7DB8D6',
    'Orange': '#F26A0D',
    'Purple': '#7A5885',
    'Yellow': '#F5D916'
  };
  /* Shirt colorway swatch dots (fallback while a chip photo loads or for any
     value without one). Hexes sampled from each colorway's own calibrated
     mockup photo midtone. Keyed by option VALUE — a value rename must update
     this map alongside variant_display. */
  var SHIRT_SWATCHES = {
    'White': '#F4F4F2',
    'Black': '#17181C',
    'Navy': '#232B3F',
    'Athletic Heather': '#CDCFD1',
    'Dark Grey Heather': '#3E3C3E',
    'Asphalt': '#53524F',
    'Natural': '#E9DFCB',
    'Light Blue': '#AECAE4',
    /* Kids ladder colorways (2026-08-06): youth/toddler True Royal + Pink,
       infant Heather + Royal (Rabbit Skins names). */
    'True Royal': '#2D4E9E',
    'Pink': '#F2B8C6',
    'Heather': '#C4C5C7',
    'Royal': '#2B4C9B',
    /* Adult color extension (2026-08-11, top-39 palette): vendor
       designer-api hexes (bp12 color_first area). True Royal + Pink keep
       the kids entries above; the adult PDP's variant_display config
       carries its own values and wins where present. */
    'Vintage White': '#F0ECE8',
    'Vintage Black': '#202125',
    'Black Heather': '#080706',
    'Soft Cream': '#F1DAB7',
    'Silver': '#D6D5D1',
    'Tan': '#D6C4B0',
    'Red': '#BA2326',
    'Heather Red': '#DD353C',
    'Maroon': '#59242A',
    'Soft Pink': '#FFEAE5',
    'Heather Raspberry': '#D56280',
    'Heather Navy': '#2E2E3C',
    'Dusty Blue': '#AFC9BF',
    'Baby Blue': '#BFD2EB',
    'Heather Deep Teal': '#4D7C8C',
    'Kelly': '#026539',
    'Heather Kelly': '#00BF85',
    'Military Green': '#515942',
    'Forest': '#20362F',
    'Sage': '#97A393',
    'Heather Olive': '#8C7555',
    'Gold': '#FFB532',
    'Mustard': '#E8A52A',
    'Burnt Orange': '#E6814A',
    'Yellow': '#FFFB81',
    'Team Purple': '#3C1F66',
    'Lilac': '#E3C2DB',
    'Mint': '#B8E0C2',
    'Heather Peach': '#FFCAAC'
  };
  /* Shirt color-card chips: each colorway's own calibrated blank-front
     mockup photo (durable CloudFront homes, the harvest of 2026-08-05). */
  var SHIRT_CHIP_IMAGES = {
    'White': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-white-m/top/1785971523049-51f3e3be-f069-4318-8db5-73018aa90231/original.jpg',
    'Black': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-black-m/top/1785971620111-904049c9-60eb-428c-a00f-64d0b1fc24bf/original.jpg',
    'Navy': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-navy-m/top/1785971649313-a040c86c-a217-4110-bf31-ecbe45a69c94/original.jpg',
    'Athletic Heather': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-athletic-heather-m/top/1785971677310-d1df2c6b-0ccf-4fdf-8ba2-40a839e88429/original.jpg',
    'Dark Grey Heather': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-dark-grey-heather-m/top/1785971706800-21ced898-52c2-4425-be0f-598386965406/original.jpg',
    'Asphalt': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt/top/1785970290400-c08458c7-bf7d-473f-95c6-003ff35f5424/original.jpg',
    'Natural': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-natural-m/top/1785971736605-c46a4141-6c24-41a6-8615-6a5b29eb1350/original.jpg',
    'Light Blue': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-light-blue-m/top/1785971763784-f4475492-876b-4aed-88ef-f09fe0c8a280/original.jpg',
    /* Kids ladder colorways (2026-08-06 harvest, durable CloudFront homes):
       True Royal + Pink ride the youth mockups (same B+C colorway family as
       toddler); Heather + Royal are the infant Rabbit Skins colorways. */
    'True Royal': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-youth-shirt-true-royal-m/top/1786027622124-9197c6f8-0d4d-4750-82e3-9500a01ee794/original.jpg',
    'Pink': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-youth-shirt-pink-m/top/1786027729694-a9926b2e-be85-4b70-b9c1-f57300eb8310/original.jpg',
    'Heather': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-infant-shirt-heather-12m/top/1786028076604-054df6e1-67dd-4dee-8749-469aa64b375e/original.jpg',
    'Royal': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-infant-shirt-royal-12m/top/1786028265114-083b95e5-cb2a-4dee-81d4-4679f6cfe72b/original.jpg',
    /* Adult color extension (2026-08-11 harvest sweep, top-39 palette):
       per-color blank-front mockups on their durable CloudFront homes. */
    'Vintage White': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-vintage-white-m/top/1786463274990-c7baee11-55cd-47ea-b010-ec4a626c8ddf/original.jpg',
    'Vintage Black': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-vintage-black-m/top/1786463423609-01e5149b-9209-4b08-a255-6cafd0b2c09d/original.jpg',
    'Black Heather': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-black-heather-m/top/1786463545420-adca0d5c-6df5-453c-82dc-59f81ce8fe32/original.jpg',
    'Soft Cream': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-soft-cream-m/top/1786463661107-0a01efed-e483-42ec-b847-9641cb91bd5e/original.jpg',
    'Silver': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-silver-m/top/1786463778556-ad92750b-7f52-474c-bf1d-eb008598143b/original.jpg',
    'Tan': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-tan-m/top/1786463897583-ca1646a5-6142-4eaa-9546-29fa10164c85/original.jpg',
    'Red': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-red-m/top/1786464021149-e18191ef-5072-4069-a12c-adc2d8780156/original.jpg',
    'Heather Red': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-heather-red-m/top/1786464252005-b4a70377-df44-4105-ab5b-5d2cc30207c8/original.jpg',
    'Maroon': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-maroon-m/top/1786464377343-768873ab-1019-4e07-b814-8103228c30ff/original.jpg',
    'Soft Pink': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-soft-pink-m/top/1786464610641-3e048519-5b16-455e-ab65-a9077d9dfefd/original.jpg',
    'Heather Raspberry': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-heather-raspberry-m/top/1786464731361-dcdc006b-c00a-4589-858c-6f38acc06061/original.jpg',
    'Heather Navy': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-heather-navy-m/top/1786464960597-7e8c5fe9-5d50-430e-8fb1-9e8e9b3bfa50/original.jpg',
    'Dusty Blue': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-dusty-blue-m/top/1786465078973-dc8d912e-cdbf-4a6a-8998-5ba68f5028b4/original.jpg',
    'Baby Blue': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-baby-blue-m/top/1786465191969-495c939f-bba0-491b-ae8a-885956883fbd/original.jpg',
    'Heather Deep Teal': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-heather-deep-teal-m/top/1786465311329-c9dd12d5-3aac-4fab-9bd5-784576a95f03/original.jpg',
    'Kelly': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-kelly-m/top/1786465431863-fbf5f4e5-d448-4f9d-9d29-f3905d718874/original.jpg',
    'Heather Kelly': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-heather-kelly-m/top/1786465550101-883b1f57-baa6-496e-bf16-07c1867fc2cd/original.jpg',
    'Military Green': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-military-green-m/top/1786465663191-023d07aa-12d4-4528-a512-4a29b7bd62d4/original.jpg',
    'Forest': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-forest-m/top/1786465788018-e21e1c88-49c5-4a30-b366-dd53edb89ffe/original.jpg',
    'Sage': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-sage-m/top/1786465910171-70b243ce-6ab0-4948-891a-0c742dbe72d0/original.jpg',
    'Heather Olive': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-heather-olive-m/top/1786466030857-35511476-958a-4f70-bd7d-649d7aea7e11/original.jpg',
    'Gold': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-gold-m/top/1786466148651-a7e020fb-c292-44e7-b6eb-d81f49f50e99/original.jpg',
    'Mustard': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-mustard-m/top/1786466263020-d594dbd3-71b9-4b39-ab2c-ebcd3d3afb68/original.jpg',
    'Burnt Orange': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-burnt-orange-m/top/1786466374877-4dacf012-733a-4313-8114-e4237a506384/original.jpg',
    'Yellow': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-yellow-m/top/1786466491983-c37cada1-a78e-43bf-87ee-7ecddbada38a/original.jpg',
    'Team Purple': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-team-purple-m/top/1786466610056-9c8e31c5-f091-4015-babc-02eaf8a1b246/original.jpg',
    'Lilac': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-lilac-m/top/1786466726144-96696099-f35c-4dcc-a74e-c0bc39a1de74/original.jpg',
    'Mint': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-mint-m/top/1786466847378-94791ff4-adf3-46a1-85e8-b2ab257dbc91/original.jpg',
    'Heather Peach': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-shirt-heather-peach-m/top/1786466965834-dca0eec0-eb1a-4cc2-9c13-e88f5eceb6be/original.jpg'
  };
  /* Zip-up hoodie (launch 2026-09, bp66 Gildan 18600 full-zip on the same
     printer as the pullover). Features rail keyed 'default'; facts from the
     approved copy spec/vendor prose: DTG print, 8 oz Heavy Blend fleece,
     two printable areas (front + back), make-it-right guarantee. */
  var ZIP_HOODIE_FEATURES = {
    'default': [['print', 'Printed Into the Fleece'], ['neoprene', '8 oz Heavy Blend Fleece'], ['sewn', 'Front + Back Printable'], ['guarantee', 'Arrives Wrong? We Make It Right']]
  };
  /* Zip-up colorway swatch dots: the 13 SwiftPOD bp66 colorways are the same
     Gildan Heavy Blend dye lots as the pullover, so the hexes are the
     pullover's sampled midtones (re-sample from the zip harvest if a color
     reads off). Chips are the per-color blank-front zip mockups on their
     durable CloudFront homes, filled from the zip-hoodie-color-harvests run;
     an absent chip falls back to the swatch dot. Keyed by option VALUE. */
  var ZIP_HOODIE_SWATCHES = {
    'Black': '#1D1D1D',
    'White': '#ECEDED',
    'Navy': '#1F2537',
    'Sport Grey': '#A5A5A6',
    'Dark Heather': '#404040',
    'Ash': '#D6D7D7',
    'Maroon': '#5A2733',
    'Red': '#B8272D',
    'Royal': '#124689',
    'Purple': '#392249',
    'Irish Green': '#268531',
    'Forest Green': '#253928',
    'Dark Chocolate': '#332623'
  };
  var ZIP_HOODIE_CHIP_IMAGES = {
    'Black': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-zip-up-hoodie-black-m/top/1789175367052-f4d0316b-fc36-425c-ae2b-57a176d3a020/original.jpg',
    'White': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-zip-up-hoodie-white-m/top/1789175531051-0e3328a1-758e-4692-8d72-fa5968cdcc0c/original.jpg',
    'Navy': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-zip-up-hoodie-navy-m/top/1789175593570-13780c38-7d20-48d0-b5ee-4aa60c93195c/original.jpg',
    'Sport Grey': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-zip-up-hoodie-sport-grey-m/top/1789175648733-b5880245-0429-4cb5-953f-1b13b71a1be9/original.jpg',
    'Dark Heather': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-zip-up-hoodie-dark-heather-m/top/1789175703185-2debd3af-bc08-4801-9037-d1a2eb76a0be/original.jpg',
    'Ash': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-zip-up-hoodie-ash-m/top/1789175765285-71083cfb-70c1-4d87-968b-72fa6f6e1ce2/original.jpg',
    'Maroon': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-zip-up-hoodie-maroon-m/top/1789175819846-2049a55f-2d42-414e-88f7-921c76efec4d/original.jpg',
    'Red': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-zip-up-hoodie-red-m/top/1789175871828-0a021ccc-bffb-47c0-8d23-fa31fe965df4/original.jpg',
    'Royal': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-zip-up-hoodie-royal-m/top/1789175924688-f5e3d956-b112-461c-9cb3-9abb4dbce183/original.jpg',
    'Purple': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-zip-up-hoodie-purple-m/top/1789175975658-b7bf5280-a717-470c-a0a3-24d043c6fc8c/original.jpg',
    'Irish Green': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-zip-up-hoodie-irish-green-m/top/1789176047522-b1b34c5b-1fa6-4acd-9fa8-83fe20c139c5/original.jpg',
    'Forest Green': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-zip-up-hoodie-forest-green-m/top/1789176130797-f5273623-411b-462b-88a3-f857b97057ec/original.jpg',
    'Dark Chocolate': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-zip-up-hoodie-dark-chocolate-m/top/1789176203008-67a52377-537d-49e4-bed7-0e2c75efaf3e/original.jpg'
  };
  /* Hoodie features rail — keyed 'default' (value renames can never kill
     it; kindle lesson). Facts from the approved copy spec/vendor prose:
     DTG print, 8.0 oz Heavy Blend fleece, five printable areas,
     make-it-right guarantee. */
  var HOODIE_FEATURES = {
    'default': [['print', 'Printed Into the Fleece'], ['neoprene', '8.0 oz Heavy Blend Fleece'], ['sewn', '5 Printable Areas'], ['guarantee', 'Arrives Wrong? We Make It Right']]
  };
  /* Hoodie colorway swatch dots + chips: hexes sampled from each colorway's
     own calibrated mockup photo midtone (2026-08-06 harvest); chips are the
     per-color blank-front mockups on their durable CloudFront homes. Keyed
     by option VALUE — a value rename must update this map alongside
     variant_display. */
  var HOODIE_SWATCHES = {
    'Black': '#1D1D1D',
    'White': '#ECEDED',
    'Navy': '#1F2537',
    'Sport Grey': '#A5A5A6',
    'Dark Heather': '#404040',
    'Ash': '#D6D7D7',
    'Maroon': '#5A2733',
    'Red': '#B8272D',
    'Royal': '#124689',
    'Carolina Blue': '#6C94D0',
    'Light Blue': '#C9D9ED',
    'Antique Sapphire': '#18658B',
    'Purple': '#392249',
    'Heliconia': '#D44677',
    'Light Pink': '#F2D2DF',
    'Orange': '#E05221',
    'Gold': '#F8A81B',
    'Irish Green': '#268531',
    'Forest Green': '#253928',
    'Military Green': '#585B45',
    'Sand': '#D1C5B1',
    'Dark Chocolate': '#332623'
  };
  var HOODIE_CHIP_IMAGES = {
    'Black': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-black-m/top/1786026275785-6792e234-e4b1-4bae-ba20-7a464f644302/original.jpg',
    'White': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-white-m/top/1786026425127-eae9c0e5-2456-4d0d-b076-8d214a7b8b13/original.jpg',
    'Navy': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-navy-m/top/1786026488673-7de8b3c7-dd45-4e4e-accf-c02aa0c84a14/original.jpg',
    'Sport Grey': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-sport-grey-m/top/1786026558273-cb4ea727-1b50-4b67-9fdd-ab5f588a24d6/original.jpg',
    'Dark Heather': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-dark-heather-m/top/1786026626088-36e79820-b4b9-4870-bed1-31492a743300/original.jpg',
    'Ash': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-ash-m/top/1786026690769-79ad535a-984b-44f9-bc4a-3baf104040ed/original.jpg',
    'Maroon': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-maroon-m/top/1786026754189-b6fb83a4-d1c8-4a45-8447-652fb2933852/original.jpg',
    'Red': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-red-m/top/1786026819366-1c5f7923-9f0f-47de-99ce-1c05e9b70cf5/original.jpg',
    'Royal': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-royal-m/top/1786026881579-baef71a4-1fbb-4f1f-b5e0-114014e7975d/original.jpg',
    'Carolina Blue': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-carolina-blue-m/top/1786026945838-32bd7faa-13c1-44b3-a031-b546472eba19/original.jpg',
    'Light Blue': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-light-blue-m/top/1786027008470-988e01af-e016-4a57-a7f9-e5aab8daf715/original.jpg',
    'Antique Sapphire': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-antique-sapphire-m/top/1786027071917-b1cbad4a-8fb6-4358-a184-987c5b1eb0b6/original.jpg',
    'Purple': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-purple-m/top/1786027135479-c8e26255-34ef-4f6a-8284-aa24cd1fb5bd/original.jpg',
    'Heliconia': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-heliconia-m/top/1786027197290-5e69639e-9618-454c-af56-ef79d31598e7/original.jpg',
    'Light Pink': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-light-pink-m/top/1786027263672-c908a70d-59b0-4905-ab3c-44b83b71e8cf/original.jpg',
    'Orange': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-orange-m/top/1786027327555-a5ea7899-d033-4615-a181-8732b2747bf5/original.jpg',
    'Gold': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-gold-m/top/1786027392414-d6716249-5bb6-4e50-a1cb-b1465be86c5f/original.jpg',
    'Irish Green': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-irish-green-m/top/1786027457179-04180838-569b-4af3-b211-555a5060d2dc/original.jpg',
    'Forest Green': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-forest-green-m/top/1786027521349-cab236f9-f940-40bc-afc5-bd77ec80cdb1/original.jpg',
    'Military Green': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-military-green-m/top/1786027765947-8accfa55-a373-4379-a56e-9fcb1f57157c/original.jpg',
    'Sand': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-sand-m/top/1786027828869-798a7f97-7fcc-4633-8faa-b07da4cd7ea8/original.jpg',
    'Dark Chocolate': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-hoodie-dark-chocolate-m/top/1786027891807-bfa50688-8a70-41f2-b357-572ee1d2b686/original.jpg'
  };
  /* Canvas print feature rail rows — facts from the approved launch copy
     spec only (matte face, edge-to-edge print, the two profile depths,
     remake-on-defect); no material, hanging-hardware, or durability
     claims. Per-style rows with a 'default' fallback so a value rename
     can never kill the rail outright (the kindle lesson). */
  var CANVAS_FEATURES = {
    'Classic Canvas': [['print', 'Edge-to-Edge HD Print'], ['neoprene', 'Matte Canvas Face'], ['sewn', '0.75″ Classic Profile'], ['guarantee', 'Arrives Wrong? We Remake It']],
    'Gallery Canvas': [['print', 'Edge-to-Edge HD Print'], ['neoprene', 'Matte Canvas Face'], ['rugged', '1.25″ Gallery Profile'], ['guarantee', 'Arrives Wrong? We Remake It']],
    'default': [['print', 'Edge-to-Edge HD Print'], ['neoprene', 'Matte Canvas Face'], ['guarantee', 'Arrives Wrong? We Remake It']]
  };
  /* Custom Bags features rail — keyed 'default' ONLY, never by option
     value: the approved facts are family-level, and a value-keyed rail
     dies silently the day a style value is renamed. One shared row set
     for all four styles. */
  var BAG_FEATURES = {
    'default': [['print', 'Edge-to-Edge Print'], ['stitch', 'Double-Stitched Seams'], ['straps', 'Cotton Webbing Straps'], ['made', 'Printed to Order']]
  };
  /* Bag-photo chips (founder ask 2026-08-06: "Add images to the Tote
     selector") — whole-bag thumbnails on the Style cards, the rope-cap
     cap-chip pattern. Images are the durable calibrated vendor renders
     (CloudFront, style truth) from each style's preview ProductSpec.
     Keyed by option VALUE like CAP_CHIP_IMAGES — a style rename must
     update this map alongside variant_display. No swatch fallback for
     bags: a value without an image (or a failed load) simply renders
     the text-only card it renders today. */
  var BAG_STYLE_IMAGES = {
    'Everyday Tote': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-custom-bags-everyday-tote-16x16/top/1786043324625-fb807af5-c0d0-4e9b-888d-eb49b130d2d4/original.jpg',
    'Full-Coverage Tote': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-custom-bags-full-coverage-tote-16x16/top/1786043390591-1231cc69-89f0-4657-aa4a-d3b04c28276b/original.jpg',
    'Woven Tote': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-custom-bags-woven-tote-17x18/top/1786043569789-ebcfeaf2-bbc0-41b7-901b-8cd57263aebf/original.png',
    'Weekender': 'https://dxdz5onzd7lh8.cloudfront.net/mockups/__preview-custom-bags-weekender-24x13/top/1786043458280-286110a2-dec6-416e-8d56-f71aad5b7f7e/original.jpg'
  };
  /* Poster feature rail rows — facts from the approved manifest + vendor
     catalog only (museum-grade archival matte paper, heavyweight satin
     photo paper, framed = acrylic cover + built-in hanging hardware,
     300 DPI edge-to-edge, remake-on-defect). Per-style rows with a
     'default' fallback so a value rename can never kill the rail
     outright (the kindle lesson). No delivery, package, or frame-material
     claims. */
  var POSTER_FEATURES = {
    'Matte': [['print', 'Edge-to-Edge 300 DPI Print'], ['neoprene', 'Museum-Grade Matte Paper'], ['guarantee', 'Arrives Wrong? We Remake It']],
    'Satin': [['print', 'Edge-to-Edge 300 DPI Print'], ['neoprene', 'Heavyweight Satin Photo Paper'], ['guarantee', 'Arrives Wrong? We Remake It']],
    'Black Frame': [['print', 'Museum-Quality Matte Print'], ['rugged', 'Protective Acrylic Cover'], ['sewn', 'Ready to Hang'], ['guarantee', 'Arrives Wrong? We Remake It']],
    'Walnut Frame': [['print', 'Museum-Quality Matte Print'], ['rugged', 'Protective Acrylic Cover'], ['sewn', 'Ready to Hang'], ['guarantee', 'Arrives Wrong? We Remake It']],
    'White Frame': [['print', 'Museum-Quality Matte Print'], ['rugged', 'Protective Acrylic Cover'], ['sewn', 'Ready to Hang'], ['guarantee', 'Arrives Wrong? We Remake It']],
    'default': [['print', 'Edge-to-Edge 300 DPI Print'], ['guarantee', 'Arrives Wrong? We Remake It']]
  };
  /* Poster style chips — whole-poster thumbnails on the Style cards, the
     bags/rope-cap chip pattern. Images are the durable calibrated vendor
     renders (CloudFront, style truth) from each style's 16x20 preview
     ProductSpec. Keyed by option VALUE — a style rename must update this
     map alongside variant_display. A value without an image (or a failed
     load) renders the text-only card. */
  var POSTER_STYLE_IMAGES = {
    'Matte': 'https://cdn.shopify.com/s/files/1/0243/9293/files/poster-tier-matte-2.png',
    'Satin': 'https://cdn.shopify.com/s/files/1/0243/9293/files/poster-tier-satin-2.png',
    'Black Frame': 'https://cdn.shopify.com/s/files/1/0243/9293/files/poster-tier-black-frame-2.png',
    'Walnut Frame': 'https://cdn.shopify.com/s/files/1/0243/9293/files/poster-tier-walnut-frame-2.png',
    'White Frame': 'https://cdn.shopify.com/s/files/1/0243/9293/files/poster-tier-white-frame-2.png'
  };
  /* Colorway swatch dots for the rope cap's color cards (founder request
     2026-07-29: show the hat color in the chips). Hexes sampled from each
     colorway's own calibrated mockup photo (side panel midtone). Keyed by
     option VALUE - a value rename must update this map alongside
     variant_display. */
  var CAP_SWATCHES = {
    'Ivory': '#EDE6D6',
    'Blue Jean': '#47535F',
    'Moss': '#76816E',
    'Black': '#1C1C1C',
    'Chambray': '#A3BFD3',
    'Espresso': '#4E382B',
    'Granite': '#71767A',
    'Peachy': '#E8B29F'
  };
  /* Cap-photo chips (founder ask 2026-07-30): small whole-cap thumbnails on
     the color cards instead of the abstract dot — the sunwashed tones are
     close neighbors and read better across real fabric with shading, and the
     silhouette reinforces the product at the decision moment. Images are the
     calibrated per-color vendor renders, margin-safe 4:3 re-compositions
     uploaded by rope-cap-hero-reframe.ts (monorepo). Keyed by option VALUE
     like CAP_SWATCHES, which stays as the fallback for any value without an
     image (and while an image loads, via the underlying card background). */
  var CAP_CHIP_IMAGES = {
    'Ivory': 'https://cdn.shopify.com/s/files/1/0243/9293/files/rope-cap-color-ivory.png',
    'Blue Jean': 'https://cdn.shopify.com/s/files/1/0243/9293/files/rope-cap-color-blue-jean.png',
    'Moss': 'https://cdn.shopify.com/s/files/1/0243/9293/files/rope-cap-color-moss.png',
    'Black': 'https://cdn.shopify.com/s/files/1/0243/9293/files/rope-cap-color-black.png',
    'Chambray': 'https://cdn.shopify.com/s/files/1/0243/9293/files/rope-cap-color-chambray.png',
    'Espresso': 'https://cdn.shopify.com/s/files/1/0243/9293/files/rope-cap-color-espresso.png',
    'Granite': 'https://cdn.shopify.com/s/files/1/0243/9293/files/rope-cap-color-granite.png',
    'Peachy': 'https://cdn.shopify.com/s/files/1/0243/9293/files/rope-cap-color-peachy.png'
  };
  function initAmRail(hero, amSel, amCards, featuresMap) {
    var features = featuresMap || AIRPODS_FEATURES;
    var active =
      amSel.querySelector('.ce-product-hero__visual-card.is-selected, .ce-product-hero__option-swatch.is-selected') ||
      amCards[0];
    if (!active) return;
    var val = active.getAttribute('data-value') || '';
    /* Per-value rows win; 'default' serves value-agnostic families (kindle).
       rowsKey only picks the ROW SET — the header and the re-render dedupe
       stay keyed on the real card value. */
    var rowsKey = features[val] ? val : (features['default'] ? 'default' : null);
    if (!rowsKey) return;

    var rail = amSel.nextElementSibling;
    if (!rail || !rail.classList.contains('e-tier-rail')) {
      rail = document.createElement('div');
      rail.className = 'e-tier-rail';
      rail.setAttribute('aria-live', 'polite');
      rail.setAttribute('aria-atomic', 'true');
      amSel.insertAdjacentElement('afterend', rail);
    }
    if (rail.__ceTier === val) return;
    rail.__ceTier = val;

    var vd = matVariantDisplay(hero);
    var vCfg = (vd && vd.option1 && vd.option1.values && vd.option1.values[val]) || {};
    var headText = vCfg.name || val;

    var base = elevateAssetBase();
    rail.innerHTML = '';
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = headText + ' includes';
    rail.appendChild(sr);

    var head = document.createElement('div');
    head.className = 'e-tier-rail__head';
    var nm = document.createElement('span');
    nm.className = 'e-tier-rail__name';
    nm.textContent = headText;
    head.appendChild(nm);
    rail.appendChild(head);

    var ul = document.createElement('ul');
    ul.className = 'e-tier-rail__items';
    features[rowsKey].forEach(function (row, ri) {
      var li = document.createElement('li');
      li.style.setProperty('--e-rail-i', ri);
      var icon = document.createElement('img');
      icon.className = 'e-tier-rail__icon';
      icon.src = base + 'icon-usp-' + row[0] + '.png';
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');
      icon.width = 12;
      icon.height = 12;
      icon.loading = 'lazy';
      li.appendChild(icon);
      var label = document.createElement('span');
      label.className = 'e-tier-rail__label';
      label.textContent = row[1];
      li.appendChild(label);
      ul.appendChild(li);
    });
    rail.appendChild(ul);

    rail.classList.remove('is-in');
    requestAnimationFrame(function () { rail.classList.add('is-in'); });
  }

  /* iPad "Help me find my model": a link under the model cards opens a
     panel with the Settings steps and a search over IPAD_MODELS (Model
     Name words or the A number). A result that fits carries a Select
     button that clicks the matching card, so price, CTA and rail follow
     the same path as a tap. Built once per option group; decorate re-runs
     on every state change, and a machinery re-render just rebuilds it. */
  var IPAD_ORDINALS = {
    first: '1st', second: '2nd', third: '3rd', fourth: '4th', fifth: '5th', sixth: '6th',
    seventh: '7th', eighth: '8th', ninth: '9th', tenth: '10th', eleventh: '11th'
  };
  var IPAD_STOPWORDS = { apple: 1, the: 1, my: 1, model: 1, wifi: 1, wi: 1, fi: 1, cellular: 1, a: 1, and: 1 };
  function ipadNorm(s) {
    return String(s || '').toLowerCase()
      .replace(/[‐-―]/g, '-')
      .replace(/\b(first|second|third|fourth|fifth|sixth|seventh|eighth|ninth|tenth|eleventh)\b/g, function (w) { return IPAD_ORDINALS[w]; })
      .replace(/\b(generations?|gen)\b/g, 'gen')
      .replace(/(\d)\s*(-\s*)?(inch(es)?\b|in\b|["”″])/g, '$1 ')
      .replace(/\binch(es)?\b/g, ' ')
      .replace(/[^a-z0-9.]+/g, ' ')
      .replace(/(^|\s)\.+|\.+(?=\s|$)/g, ' ')
      .trim();
  }
  var ipadIndex = null;
  function ipadModelIndex() {
    if (ipadIndex) return ipadIndex;
    ipadIndex = IPAD_MODELS.map(function (row) {
      var nameToks = ipadNorm(row[0] + ' ' + row[1]).split(' ');
      var extraToks = ipadNorm(row[2] + ' ' + row[4]).split(' ').filter(Boolean);
      return { name: row[0], year: row[1], fit: row[3], exact: ipadNorm(row[0]), nameToks: nameToks, extraToks: extraToks };
    });
    return ipadIndex;
  }
  /* Every query word must hit the model (AND). Name words outrank the
     extra words, exact outranks prefix, and the whole Model Name typed as
     Settings shows it wins outright ("iPad Pro 11-inch" is the 2018 model,
     not every Pro 11). A bare 4-digit word also tries the A number ("2902"
     finds A2902). */
  function ipadSearch(query) {
    var whole = ipadNorm(query);
    var words = whole.split(' ').filter(function (w) { return w && !IPAD_STOPWORDS[w]; });
    if (!words.length) return [];
    var hits = [];
    ipadModelIndex().forEach(function (m, order) {
      var score = (words.length > 1 && m.exact === whole) ? 100 : 0;
      for (var i = 0; i < words.length; i++) {
        var w = words[i];
        var alt = /^\d{4}$/.test(w) ? 'a' + w : null;
        var best = 0;
        for (var n = 0; n < m.nameToks.length; n++) {
          var t = m.nameToks[n];
          if (t === w) best = Math.max(best, 4);
          else if (t.indexOf(w) === 0) best = Math.max(best, 3);
        }
        for (var x = 0; x < m.extraToks.length; x++) {
          var e = m.extraToks[x];
          if (e === w || e === alt) best = Math.max(best, 2);
          else if (e.indexOf(w) === 0) best = Math.max(best, 1);
        }
        if (!best) return;
        score += best;
      }
      hits.push({ m: m, score: score, order: order });
    });
    hits.sort(function (p, q) {
      return (q.score - p.score) || ((q.m.fit ? 1 : 0) - (p.m.fit ? 1 : 0)) ||
        (q.m.year - p.m.year) || (p.order - q.order);
    });
    return hits.map(function (h) { return h.m; });
  }
  function heroCurrentProduct(hero) {
    if (hero.__ceCP !== undefined) return hero.__ceCP;
    hero.__ceCP = null;
    var sect = hero.closest('[id^="shopify-section-"]') || document;
    var tag = sect.querySelector('script[id^="ce-hero-config-"]');
    if (tag) {
      try { hero.__ceCP = (JSON.parse(tag.textContent) || {}).currentProduct || null; }
      catch (e) { /* stay null */ }
    }
    return hero.__ceCP;
  }
  /* vendor size id (SKU tail) -> the live card for it, or null when the
     variant is gone or the card is sold out. Read fresh on every use. */
  function ipadCardFor(hero, sel, fitId) {
    if (!fitId) return null;
    var cp = heroCurrentProduct(hero);
    var variants = (cp && cp.variants) || [];
    var value = null;
    for (var i = 0; i < variants.length && value === null; i++) {
      var m = /-(\d+)$/.exec(variants[i].sku || '');
      if (m && Number(m[1]) === fitId) value = variants[i].option1;
    }
    if (value === null) return null;
    var cards = sel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]');
    for (var c = 0; c < cards.length; c++) {
      if (cards[c].getAttribute('data-value') === value) {
        return cards[c].classList.contains('is-unavailable') ? null : cards[c];
      }
    }
    return null;
  }
  var ipadFinderSeq = 0;
  function initIpadFinder(hero, sel) {
    var group = sel.querySelector('.ce-product-hero__option-group[data-option-key="option1"]') || sel;
    if (group.querySelector('.e-ipad-finder')) return;
    var uid = 'e-ipad-finder-' + (++ipadFinderSeq);

    var wrap = document.createElement('div');
    wrap.className = 'e-ipad-finder';
    wrap.innerHTML =
      '<p class="e-ipad-finder__lead">Not sure which iPad you have? ' +
        '<button type="button" class="e-ipad-finder__toggle" aria-expanded="false" aria-controls="' + uid + '-panel">Help me find my model</button>' +
      '</p>' +
      '<p class="e-ipad-finder__done" role="status" aria-live="polite"></p>' +
      '<div class="e-ipad-finder__panel" id="' + uid + '-panel" hidden>' +
        '<p class="e-ipad-finder__title">Find your iPad model</p>' +
        '<ol class="e-ipad-finder__steps">' +
          '<li>On your iPad, open <b>Settings</b>.</li>' +
          '<li>Tap <b>General</b>, then <b>About</b>.</li>' +
          '<li>Type the <b>Model Name</b> below, like iPad Air 11-inch (M2). ' +
            'Or tap <b>Model Number</b> once to see a number that starts with A, like A2902.</li>' +
        '</ol>' +
        '<label class="e-ipad-finder__label" for="' + uid + '-q">Search your iPad model</label>' +
        '<input class="e-ipad-finder__input" id="' + uid + '-q" type="search" autocomplete="off" ' +
          'autocapitalize="none" autocorrect="off" spellcheck="false" enterkeyhint="search" ' +
          'placeholder="iPad Air 11-inch (M2) or A2902" aria-describedby="' + uid + '-msg">' +
        '<p class="e-ipad-finder__msg" id="' + uid + '-msg" aria-live="polite"></p>' +
        '<ul class="e-ipad-finder__results"></ul>' +
        '<p class="e-ipad-finder__foot">No Settings handy? The A number is also printed in small type on the back of your iPad.</p>' +
      '</div>';
    group.appendChild(wrap);

    var toggle = wrap.querySelector('.e-ipad-finder__toggle');
    var panel = wrap.querySelector('.e-ipad-finder__panel');
    var input = wrap.querySelector('.e-ipad-finder__input');
    var msg = wrap.querySelector('.e-ipad-finder__msg');
    var list = wrap.querySelector('.e-ipad-finder__results');
    var done = wrap.querySelector('.e-ipad-finder__done');
    var MAX_ROWS = 6;

    function setOpen(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        done.textContent = '';
        try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
      }
    }
    toggle.addEventListener('click', function () { setOpen(panel.hidden); });

    function pick(model, card) {
      var cardName = (card.querySelector('.ce-product-hero__vc-name') || card).textContent.trim();
      if (!card.classList.contains('is-selected')) card.click();
      setOpen(false);
      done.textContent = 'Selected ' + cardName + ', the folio that fits your ' + model.name + '.';
      card.classList.add('e-ipad-finder-flash');
      setTimeout(function () { card.classList.remove('e-ipad-finder-flash'); }, 1600);
      /* Phones show the cards as a sideways row: center the picked card in
         the row's own scroll, then nudge the page only if the card is off
         screen (a bare scrollIntoView moved both axes at once). */
      var grid = card.parentElement;
      if (grid && grid.scrollWidth > grid.clientWidth + 1) {
        var gBox = grid.getBoundingClientRect();
        var cBox = card.getBoundingClientRect();
        var left = grid.scrollLeft + (cBox.left - gBox.left) - (gBox.width - cBox.width) / 2;
        try { grid.scrollTo({ left: left, behavior: 'smooth' }); } catch (e) { grid.scrollLeft = left; }
      }
      var vBox = card.getBoundingClientRect();
      if (vBox.top < 0 || vBox.bottom > window.innerHeight) {
        var dy = vBox.top - Math.max(16, (window.innerHeight - vBox.height) / 3);
        try { window.scrollBy({ top: dy, behavior: 'smooth' }); } catch (e) { window.scrollBy(0, dy); }
      }
      try { toggle.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }

    function render() {
      var q = input.value.trim();
      list.innerHTML = '';
      msg.textContent = '';
      if (!q) return [];
      var found = ipadSearch(q);
      if (!found.length) {
        var compact = q.replace(/\s+/g, '');
        if (/\/a$/i.test(compact) || /^[mfnp][a-z0-9]{3}\d(ll|zm|zp|lz)/i.test(compact)) {
          msg.textContent = 'That looks like the part number. Tap Model Number once in Settings and it switches to a number that starts with A.';
        } else if (/^a?\d{4}$/i.test(compact)) {
          msg.textContent = 'We could not find that number. Check that it starts with A and has four digits, like A2902.';
        } else {
          msg.textContent = 'No match yet. Try the Model Name exactly as Settings shows it, or the A number.';
        }
        return [];
      }
      var rows = found.slice(0, MAX_ROWS);
      var fits = [];
      rows.forEach(function (model) {
        var card = ipadCardFor(hero, sel, model.fit);
        var li = document.createElement('li');
        li.className = 'e-ipad-finder__row' + (card ? ' is-fit' : ' is-nofit');
        var body = document.createElement('div');
        body.className = 'e-ipad-finder__model';
        var nm = document.createElement('span');
        nm.className = 'e-ipad-finder__name';
        nm.textContent = model.name;
        var yr = document.createElement('span');
        yr.className = 'e-ipad-finder__year';
        yr.textContent = String(model.year);
        var verdict = document.createElement('span');
        verdict.className = 'e-ipad-finder__verdict';
        body.appendChild(nm);
        body.appendChild(yr);
        body.appendChild(verdict);
        li.appendChild(body);
        if (card) {
          var cardName = (card.querySelector('.ce-product-hero__vc-name') || card).textContent.trim();
          verdict.textContent = 'Fits our ' + cardName + ' folio';
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'e-ipad-finder__pick';
          btn.textContent = 'Select';
          btn.setAttribute('aria-label', 'Select ' + cardName + ' for ' + model.name);
          btn.addEventListener('click', function () { pick(model, ipadCardFor(hero, sel, model.fit) || card); });
          li.appendChild(btn);
          fits.push({ model: model, card: card });
        } else {
          verdict.textContent = 'We do not make a folio for this iPad yet';
        }
        list.appendChild(li);
      });
      if (found.length > MAX_ROWS) {
        msg.textContent = 'Showing the closest ' + MAX_ROWS + '. Add more of the Model Name to narrow it down.';
      }
      return fits;
    }
    input.addEventListener('input', render);
    input.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') {
        ev.preventDefault();
        var fits = render();
        var rows = list.querySelectorAll('.e-ipad-finder__row');
        if (rows.length === 1 && fits.length === 1) pick(fits[0].model, fits[0].card);
      } else if (ev.key === 'Escape') {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  function decorateNonCaseOffer() {
    var hero = document.querySelector('.ce-product-hero');
    if (!hero) return;
    if (!hero.querySelector('.ce-product-hero__combined-selector') &&
        !hero.querySelector('.ce-product-hero__individual-selector')) return;
    var h1 = document.querySelector('h1');
    var title = (h1 ? h1.textContent : document.title) || '';
    var noun = nonCaseNoun(title);

    /* under-CTA line: case-style single line, no guarantee. If the
       template's fallback pill still says "Case" on a non-case page,
       name the actual product. */
    hero.querySelectorAll('.ce-product-hero__sub-cta').forEach(function (el) {
      if (el.__ceRewritten) return;
      var m = el.textContent.match(/Get a\s+(.+?)\s*·/);
      if (!m) return;
      el.__ceRewritten = true;
      var offerText = m[1];
      if (noun && /\bcase\b/i.test(offerText)) {
        offerText = offerText.replace(/\bcase\b/ig, titleCaseNoun(noun));
      }
      for (var n = el.lastChild, prev; n; n = prev) {
        prev = n.previousSibling;
        if (n.nodeType === 3) { el.removeChild(n); }
      }
      el.appendChild(document.createTextNode(' ' + offerText + ' · Applied Automatically'));
    });

    /* option-card offer chips -> case-style FREE lockup. The chip text
       comes from admin config (variant_display / bogo pill) that may
       still say "Case" on non-case products — correct the noun here. */
    hero.querySelectorAll('.ce-product-hero__vc-bogo').forEach(function (chip) {
      if (chip.__ceLockup) return;
      var words = chip.textContent.replace(/\s*free\s*$/i, '').trim().toLowerCase().split(/\s+/);
      if (!words.length || !words[0]) return;
      chip.__ceLockup = true;
      var label = words.map(function (w) {
        return /^\d/.test(w) ? w : w.charAt(0).toUpperCase() + w.slice(1);
      }).join(' ');
      if (noun && /\bcase\b/i.test(label)) {
        label = label.replace(/\bcase\b/ig, titleCaseNoun(noun));
      }
      chip.classList.add('e-vc-offer');
      chip.innerHTML = label + ' <b class="e-tier-offer__free">FREE' + SQUIGGLE + '</b>';
    });

    /* CTA joins the case pattern: "Design My Desk Mat · $60" — the
       machinery composes "<cta text> → $60"; swap the arrow join for
       the cases' quiet dot (re-applied after every machinery rewrite) */
    if (noun) {
      hero.querySelectorAll('[id^="ce-product-hero__cta-"]').forEach(function (btn) {
        var t = btn.textContent;
        if (/→\s*\$[\d.,]+\s*$/.test(t)) {
          btn.textContent = t.replace(/\s*→\s*(\$[\d.,]+)(\s*)$/, ' · $1$2');
        }
      });
    }

    /* desk-mat size cards: case-tier-card structure (no photo chip) —
       name / size / price / FREE line; scope class for the skin */
    if (noun === 'desk mat') {
      hero.classList.add('e-mat-hero');
      hero.querySelectorAll('.ce-product-hero__visual-card').forEach(function (card) {
        var nameEl = card.querySelector('.ce-product-hero__vc-name');
        if (nameEl && !nameEl.querySelector('.e-vc-size')) {
          /* split the single frozen value ('XXL Desk Mat (18" x 36")')
             into a bold name line + a smaller size line — the size
             still appears exactly once (the old duplicate sub-line is
             hidden by the skin) */
          var nm = nameEl.textContent.match(/^\s*(.*?)\s*\(([^)]+)\)\s*$/);
          if (nm) {
            nameEl.textContent = nm[1];
            var sz = document.createElement('span');
            sz.className = 'e-vc-size';
            sz.textContent = nm[2];
            nameEl.appendChild(sz);
          }
        }
        var priceEl = card.querySelector('.ce-product-hero__vc-price');
        if (priceEl) {
          /* one variant per size — the exact price, not a "From" hedge */
          priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
          var right = priceEl.parentNode;
          if (right && !right.querySelector('.e-tier-offer')) {
            var offer = document.createElement('div');
            offer.className = 'e-tier-offer';
            offer.appendChild(document.createTextNode('2nd Desk Mat '));
            var free = document.createElement('b');
            free.className = 'e-tier-offer__free';
            free.innerHTML = 'FREE' + SQUIGGLE;
            offer.appendChild(free);
            right.appendChild(offer);
          }
        }
      });
    }

    /* desk-mat Podium Rail (ports the case selector redesign): the four
       per-size feature rows are gone from the cards — three of the four
       were the same string on four of the five sizes, so they cost height
       and taught nothing. The dimensions line on the chip is the one
       honest discriminator; the full feature set lives in ONE rail under
       the grid that rewrites itself for the selected size. Selecting IS
       the disclosure.

       The merchant's variant_display metafield already names the hero
       size (badge "Customer favorite" + "default" on XXL) — honor that
       config: the default card is selected from first paint via a real
       machinery click (individual mode never preselects on its own), so
       the CTA price and the rail agree with state from the start. */
    if (noun === 'desk mat') {
      var matSel = hero.querySelector('.ce-product-hero__individual-selector');
      var matCards = matSel ? matSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (matCards.length) {
        if (!hero.__ceMatDefaulted && !matSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceMatDefaulted = true;
          var mvd = matVariantDisplay(hero);
          var defVal = mvd && mvd.option1 && mvd.option1['default'];
          var defCard = null;
          for (var di = 0; di < matCards.length && !defCard; di++) {
            if (defVal && matCards[di].getAttribute('data-value') === defVal) defCard = matCards[di];
          }
          for (var bi = 0; bi < matCards.length && !defCard; bi++) {
            if (matCards[bi].querySelector('.ce-product-hero__vc-badge')) defCard = matCards[bi];
          }
          /* through the machinery's own click path so variant/state/events
             stay canonical (the click re-runs this decorator via
             ce:state-change; the flag above keeps it single-shot) */
          if (defCard) defCard.click();
        }
        initMatRail(hero, matSel, matCards);
      }
    }

    /* blanket size cards: case-tier-card structure — the machinery's
       plain-card path renders only name + desc, so build the rest:
       price slot, "2nd Blanket FREE" lockup, and the MOST POPULAR
       badge the template configures but the renderer drops. The price
       is the exact variant price for the chosen material (the product
       JSON fetched above); until a material is picked — or for combos
       that don't exist in that material — the slot stays the
       reserved-invisible line, so the card never grows or shifts. */
    if (noun === 'blanket') {
      hero.classList.add('e-blanket-hero');
      fetchNonCaseProduct();
      var selMat = hero.querySelector('.ce-product-hero__visual-card.is-selected[data-option-key="option1"]');
      var matVal = selMat ? selMat.getAttribute('data-value') : null;
      var prod = NONCASE_PRODUCT.data;
      hero.querySelectorAll('.ce-product-hero__option-card').forEach(function (card) {
        var val = card.getAttribute('data-value');
        var price = card.querySelector('.ce-oc-price');
        if (!price) {
          price = document.createElement('div');
          price.className = 'ce-oc-price e-oc-price-pending';
          price.innerHTML = '&nbsp;';
          card.appendChild(price);
        }
        if (!card.querySelector('.e-tier-offer')) {
          var offer = document.createElement('div');
          offer.className = 'e-tier-offer';
          offer.appendChild(document.createTextNode('2nd Blanket '));
          var free = document.createElement('b');
          free.className = 'e-tier-offer__free';
          free.innerHTML = 'FREE' + SQUIGGLE;
          offer.appendChild(free);
          card.appendChild(offer);
        }
        if (val && BLANKET_SIZE_BADGES[val] && !card.querySelector('.e-oc-badge')) {
          var badge = document.createElement('span');
          badge.className = 'e-oc-badge';
          badge.textContent = BLANKET_SIZE_BADGES[val];
          card.appendChild(badge);
        }
        var cents = null;
        if (prod && matVal && val) {
          (prod.variants || []).forEach(function (v) {
            if (v.option1 === matVal && v.option2 === val && v.available) cents = v.price;
          });
        }
        if (cents != null) {
          var p = cents / 100;
          price.textContent = '$' + (p % 1 === 0 ? p.toFixed(0) : p.toFixed(2));
          price.classList.remove('e-oc-price-pending');
        } else {
          price.innerHTML = '&nbsp;';
          price.classList.add('e-oc-price-pending');
        }
      });
    }

    /* cutting-board size cards: mat-style card chrome — exact price (one
       variant per size), "2nd Board FREE" lockup, default-select through
       the machinery's own click path, and the feature rail under the
       selector. */
    if (noun === 'cutting board') {
      /* boards borrow the mat's Podium Rail machinery (e-mat-hero) but
         wear the CASE selected-state skin — e-board-hero scopes that
         override so desk mats keep their dark selected card. */
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      var boardSel = hero.querySelector('.ce-product-hero__individual-selector');
      var boardCards = boardSel ? boardSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (boardCards.length) {
        if (!hero.__ceBoardDefaulted && !boardSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceBoardDefaulted = true;
          var bvd = matVariantDisplay(hero);
          var bDefVal = bvd && bvd.option1 && bvd.option1['default'];
          var bDefCard = null;
          for (var bd = 0; bd < boardCards.length && !bDefCard; bd++) {
            if (bDefVal && boardCards[bd].getAttribute('data-value') === bDefVal) bDefCard = boardCards[bd];
          }
          if (!bDefCard) bDefCard = boardCards[0];
          if (bDefCard) bDefCard.click();
        }
        /* one valid size per shape: sync the Size step to the chosen shape
           through the machinery's own click path (value-idempotent, so the
           ce:state-change re-run settles instead of looping). The Size cards
           stay visible as the dimensions disclosure. */
        fetchNonCaseProduct();
        var selShapeCard = boardSel.querySelector('.ce-product-hero__visual-card.is-selected[data-option-key="option1"]');
        var selShapeVal = selShapeCard && selShapeCard.getAttribute('data-value');
        var boardProd = NONCASE_PRODUCT.data;
        if (selShapeVal && boardProd) {
          var validSizes = [];
          (boardProd.variants || []).forEach(function (v) {
            if (v.option1 === selShapeVal && v.available !== false && validSizes.indexOf(v.option2) === -1) validSizes.push(v.option2);
          });
          if (validSizes.length) {
            /* auto-select only when the current size is missing or invalid
               for the shape — a shape with several sizes (Rectangle 8x11 /
               11x15) keeps the user's manual size choice */
            var selectedSize = null;
            var sizeCardByValue = {};
            boardSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
              var val = card.getAttribute('data-value');
              sizeCardByValue[val] = card;
              if (card.classList.contains('is-selected')) selectedSize = val;
            });
            if ((!selectedSize || validSizes.indexOf(selectedSize) === -1) && sizeCardByValue[validSizes[0]]) {
              sizeCardByValue[validSizes[0]].click();
            }
          }
        }
        boardCards.forEach(function (card) {
          var priceEl = card.querySelector('.ce-product-hero__vc-price');
          if (priceEl) {
            /* exact price only for single-size shapes — a shape with two
               sizes keeps its honest "From $X" hedge */
            var cardShape = card.getAttribute('data-value');
            var cardSizeCount = 0;
            if (NONCASE_PRODUCT.data) {
              (NONCASE_PRODUCT.data.variants || []).forEach(function (v) {
                if (v.option1 === cardShape && v.available !== false) cardSizeCount++;
              });
            }
            if (cardSizeCount === 1) {
              priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
            }
            var right = priceEl.parentNode;
            if (right && !right.querySelector('.e-tier-offer')) {
              var offer = document.createElement('div');
              offer.className = 'e-tier-offer';
              offer.appendChild(document.createTextNode('2nd Board '));
              var free = document.createElement('b');
              free.className = 'e-tier-offer__free';
              free.innerHTML = 'FREE' + SQUIGGLE;
              offer.appendChild(free);
              right.appendChild(offer);
            }
          }
        });
        initBoardRail(hero, boardSel, boardCards);
      }
    }

    /* rug style cards: same Podium Rail machinery + the case-style white
       selected skin as boards. Sparse Style x Size matrix (Round has ONE
       size, Outdoor four, Area six): picking a style syncs the Size step
       to that style's first valid size through the machinery's own click
       path, so no style card is ever a dead end. Offer chip is the
       truthful "Free Shipping" (the rug family is single-unit only —
       never a BOGO lockup). */
    /* mahjong mat: the size rail under the compact size cards (re-run on
       every ce:state-change; idempotent per selected value) */
    if (noun === 'mahjong mat') {
      var mjSel = hero.querySelector('.ce-product-hero__individual-selector');
      if (mjSel) initMahjongRail(hero, mjSel);
    }

    /* Custom Pillows (2026-10-21): open on the variant_display defaults
       (18" + Pillow + insert, the complete pillow) instead of the first
       variant (12"), once per page load so a shopper's own pick is never
       overridden. Reordering the Shopify variants is not the fix: it also
       reorders the size cards. */
    if ((noun === 'throw pillow' || noun === 'lumbar pillow' || noun === 'outdoor pillow') && !hero.__cePillowDefaulted) {
      var plSel = hero.querySelector('.ce-product-hero__individual-selector');
      if (plSel) {
        hero.__cePillowDefaulted = true;
        var plVd = matVariantDisplay(hero);
        ['option1', 'option2'].forEach(function (plKey) {
          var plDef = plVd && plVd[plKey] && plVd[plKey]['default'];
          if (!plDef) return;
          var plCards = plSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="' + plKey + '"]');
          for (var pl = 0; pl < plCards.length; pl++) {
            if (plCards[pl].getAttribute('data-value') === plDef) {
              if (!plCards[pl].classList.contains('is-selected')) plCards[pl].click();
              break;
            }
          }
        });
      }
    }

    if (noun === 'rug') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-rug-hero');
      var rugSel = hero.querySelector('.ce-product-hero__individual-selector');
      var rugCards = rugSel ? rugSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (rugCards.length) {
        if (!hero.__ceRugDefaulted && !rugSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceRugDefaulted = true;
          var rvd = matVariantDisplay(hero);
          var rDefVal = rvd && rvd.option1 && rvd.option1['default'];
          var rDefCard = null;
          for (var rd = 0; rd < rugCards.length && !rDefCard; rd++) {
            if (rDefVal && rugCards[rd].getAttribute('data-value') === rDefVal) rDefCard = rugCards[rd];
          }
          if (!rDefCard) rDefCard = rugCards[0];
          if (rDefCard) rDefCard.click();
        }
        /* sync the Size step to the chosen style (value-idempotent, so the
           ce:state-change re-run settles instead of looping) */
        fetchNonCaseProduct();
        var selStyleCard = rugSel.querySelector('.ce-product-hero__visual-card.is-selected[data-option-key="option1"]');
        var selStyleVal = selStyleCard && selStyleCard.getAttribute('data-value');
        var rugProd = NONCASE_PRODUCT.data;
        if (selStyleVal && rugProd) {
          var rugValidSizes = [];
          (rugProd.variants || []).forEach(function (v) {
            if (v.option1 === selStyleVal && v.available !== false && rugValidSizes.indexOf(v.option2) === -1) rugValidSizes.push(v.option2);
          });
          if (rugValidSizes.length) {
            var rugSelectedSize = null;
            var rugSizeCardByValue = {};
            rugSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
              var val = card.getAttribute('data-value');
              rugSizeCardByValue[val] = card;
              if (card.classList.contains('is-selected')) rugSelectedSize = val;
            });
            if ((!rugSelectedSize || rugValidSizes.indexOf(rugSelectedSize) === -1) && rugSizeCardByValue[rugValidSizes[0]]) {
              rugSizeCardByValue[rugValidSizes[0]].click();
            }
          }
        }
        /* per-size exact price under the dimensions line — the exact
           variant price for the chosen style (the product JSON fetched
           above). Until the style resolves, or for sizes the sparse
           matrix doesn't sell in that style, the slot stays the
           reserved-invisible line so the card never grows or shifts. */
        rugSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
          var sizeVal = card.getAttribute('data-value');
          var sizePrice = card.querySelector('.ce-oc-price');
          if (!sizePrice) {
            sizePrice = document.createElement('div');
            sizePrice.className = 'ce-oc-price e-oc-price-pending';
            sizePrice.innerHTML = '&nbsp;';
            card.appendChild(sizePrice);
          }
          var rugCents = null;
          if (rugProd && selStyleVal && sizeVal) {
            (rugProd.variants || []).forEach(function (v) {
              if (v.option1 === selStyleVal && v.option2 === sizeVal && v.available !== false) rugCents = v.price;
            });
          }
          if (rugCents != null) {
            var rp = rugCents / 100;
            sizePrice.textContent = '$' + (rp % 1 === 0 ? rp.toFixed(0) : rp.toFixed(2));
            sizePrice.classList.remove('e-oc-price-pending');
          } else {
            sizePrice.innerHTML = '&nbsp;';
            sizePrice.classList.add('e-oc-price-pending');
          }
        });
        rugCards.forEach(function (card) {
          var priceEl = card.querySelector('.ce-product-hero__vc-price');
          if (priceEl) {
            var cardStyle = card.getAttribute('data-value');
            var cardSizes = 0;
            if (NONCASE_PRODUCT.data) {
              (NONCASE_PRODUCT.data.variants || []).forEach(function (v) {
                if (v.option1 === cardStyle && v.available !== false) cardSizes++;
              });
            }
            if (cardSizes === 1) {
              priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
            }
            var right = priceEl.parentNode;
            if (right && !right.querySelector('.e-tier-offer')) {
              var offer = document.createElement('div');
              offer.className = 'e-tier-offer';
              offer.appendChild(document.createTextNode('Free '));
              var ship = document.createElement('b');
              ship.className = 'e-tier-offer__free';
              ship.innerHTML = 'Shipping' + SQUIGGLE;
              offer.appendChild(ship);
              right.appendChild(offer);
            }
          }
        });
        initRugRail(hero, rugSel, rugCards);
      }
    }

    /* canvas print: the rug pattern (Style visual cards + sparse Style x
       Size sync + per-size exact prices) with the pajama refinement of
       HIDING sizes the chosen profile never sells (Classic has no 20x20/
       30x40/40x30; Gallery has no 16x16 — a visible dead card would read
       as broken). Offer chip is the truthful "Free Shipping" (every
       canvas price is above the sitewide threshold; single-unit family,
       never a BOGO lockup). */
    if (noun === 'canvas print') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-cv-hero');
      var cvSel = hero.querySelector('.ce-product-hero__individual-selector');
      var cvCards = cvSel ? cvSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (cvCards.length) {
        if (!hero.__ceCvDefaulted && !cvSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceCvDefaulted = true;
          var cvd = matVariantDisplay(hero);
          var cvDefVal = cvd && cvd.option1 && cvd.option1['default'];
          var cvDefCard = null;
          for (var cd = 0; cd < cvCards.length && !cvDefCard; cd++) {
            if (cvDefVal && cvCards[cd].getAttribute('data-value') === cvDefVal) cvDefCard = cvCards[cd];
          }
          if (!cvDefCard) cvDefCard = cvCards[0];
          if (cvDefCard) cvDefCard.click();
        }
        /* profile-to-size sync (value-idempotent) + hide unsold sizes */
        fetchNonCaseProduct();
        var cvStyleCard = cvSel.querySelector('.ce-product-hero__visual-card.is-selected[data-option-key="option1"]');
        var cvStyleVal = cvStyleCard && cvStyleCard.getAttribute('data-value');
        var cvProd = NONCASE_PRODUCT.data;
        if (cvStyleVal && cvProd) {
          var cvValidSizes = [];
          (cvProd.variants || []).forEach(function (v) {
            if (v.option1 === cvStyleVal && v.available !== false && cvValidSizes.indexOf(v.option2) === -1) cvValidSizes.push(v.option2);
          });
          if (cvValidSizes.length) {
            var cvSelectedSize = null;
            var cvSizeCardByValue = {};
            cvSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
              var val = card.getAttribute('data-value');
              cvSizeCardByValue[val] = card;
              if (card.classList.contains('is-selected')) cvSelectedSize = val;
              card.style.display = cvValidSizes.indexOf(val) === -1 ? 'none' : '';
            });
            if ((!cvSelectedSize || cvValidSizes.indexOf(cvSelectedSize) === -1) && cvSizeCardByValue[cvValidSizes[0]]) {
              cvSizeCardByValue[cvValidSizes[0]].click();
            }
          }
        }
        /* per-size exact price under the size label */
        cvSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
          var cvSizeVal = card.getAttribute('data-value');
          var cvSizePrice = card.querySelector('.ce-oc-price');
          if (!cvSizePrice) {
            cvSizePrice = document.createElement('div');
            cvSizePrice.className = 'ce-oc-price e-oc-price-pending';
            cvSizePrice.innerHTML = '&nbsp;';
            card.appendChild(cvSizePrice);
          }
          var cvCents = null;
          if (cvProd && cvStyleVal && cvSizeVal) {
            (cvProd.variants || []).forEach(function (v) {
              if (v.option1 === cvStyleVal && v.option2 === cvSizeVal && v.available !== false) cvCents = v.price;
            });
          }
          if (cvCents != null) {
            var cvp = cvCents / 100;
            cvSizePrice.textContent = '$' + (cvp % 1 === 0 ? cvp.toFixed(0) : cvp.toFixed(2));
            cvSizePrice.classList.remove('e-oc-price-pending');
          } else {
            cvSizePrice.innerHTML = '&nbsp;';
            cvSizePrice.classList.add('e-oc-price-pending');
          }
        });
        cvCards.forEach(function (card) {
          var cvPriceEl = card.querySelector('.ce-product-hero__vc-price');
          if (cvPriceEl) {
            var cvRight = cvPriceEl.parentNode;
            if (cvRight && !cvRight.querySelector('.e-tier-offer')) {
              var cvOffer = document.createElement('div');
              cvOffer.className = 'e-tier-offer';
              cvOffer.appendChild(document.createTextNode('Free '));
              var cvShip = document.createElement('b');
              cvShip.className = 'e-tier-offer__free';
              cvShip.innerHTML = 'Shipping' + SQUIGGLE;
              cvOffer.appendChild(cvShip);
              cvRight.appendChild(cvOffer);
            }
          }
        });
        initAmRail(hero, cvSel, cvCards, CANVAS_FEATURES);
      }
    }

    /* christmas ornaments (2026-08-17 relaunch): the canvas-print pattern
       (Style visual cards + sparse Style x Size sync + HIDDEN unsold
       sizes + per-size exact prices) across seven styles: the four
       ceramic shapes sold Single/Set of 3/Set of 5/Set of 10 while the
       two vintage balls and the pewter snowflake were Single-only, so the
       hide-unsold-sizes sync was load-bearing. 2026-09-04: the Size axis
       was retired (singles only; the Buy More Save More ladder IS the
       multi-buy offer) and the Style cards carry the vendor's blank shape
       photo via variant_display.option1.showImages, so the option2 blocks
       below simply find no size cards and fall through. NO offer chip on any card:
       the family's offer is the shared Buy More Save More ladder, which
       the ce-qty-ladder band and the sticky pill advertise from live
       discount truth (empty approvedClaims list, so no shipping wording
       anywhere on this noun). */
    if (noun === 'ornament') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-orn-hero');
      var orSel = hero.querySelector('.ce-product-hero__individual-selector');
      var orCards = orSel ? orSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (orCards.length) {
        if (!hero.__ceOrnDefaulted && !orSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceOrnDefaulted = true;
          var ord = matVariantDisplay(hero);
          var orDefVal = ord && ord.option1 && ord.option1['default'];
          var orDefCard = null;
          for (var oc = 0; oc < orCards.length && !orDefCard; oc++) {
            if (orDefVal && orCards[oc].getAttribute('data-value') === orDefVal) orDefCard = orCards[oc];
          }
          if (!orDefCard) orDefCard = orCards[0];
          if (orDefCard) orDefCard.click();
        }
        /* style-to-size sync (value-idempotent) + hide unsold sizes */
        fetchNonCaseProduct();
        var orStyleCard = orSel.querySelector('.ce-product-hero__visual-card.is-selected[data-option-key="option1"]');
        var orStyleVal = orStyleCard && orStyleCard.getAttribute('data-value');
        var orProd = NONCASE_PRODUCT.data;
        if (orStyleVal && orProd) {
          var orValidSizes = [];
          (orProd.variants || []).forEach(function (v) {
            if (v.option1 === orStyleVal && v.available !== false && orValidSizes.indexOf(v.option2) === -1) orValidSizes.push(v.option2);
          });
          if (orValidSizes.length) {
            var orSelectedSize = null;
            var orSizeCardByValue = {};
            orSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
              var val = card.getAttribute('data-value');
              orSizeCardByValue[val] = card;
              if (card.classList.contains('is-selected')) orSelectedSize = val;
              card.style.display = orValidSizes.indexOf(val) === -1 ? 'none' : '';
            });
            if ((!orSelectedSize || orValidSizes.indexOf(orSelectedSize) === -1) && orSizeCardByValue[orValidSizes[0]]) {
              orSizeCardByValue[orValidSizes[0]].click();
            }
          }
        }
        /* per-size exact price under the size label */
        orSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
          var orSizeVal = card.getAttribute('data-value');
          var orSizePrice = card.querySelector('.ce-oc-price');
          if (!orSizePrice) {
            orSizePrice = document.createElement('div');
            orSizePrice.className = 'ce-oc-price e-oc-price-pending';
            orSizePrice.innerHTML = '&nbsp;';
            card.appendChild(orSizePrice);
          }
          var orCents = null;
          if (orProd && orStyleVal && orSizeVal) {
            (orProd.variants || []).forEach(function (v) {
              if (v.option1 === orStyleVal && v.option2 === orSizeVal && v.available !== false) orCents = v.price;
            });
          }
          if (orCents != null) {
            var orp = orCents / 100;
            orSizePrice.textContent = '$' + (orp % 1 === 0 ? orp.toFixed(0) : orp.toFixed(2));
            orSizePrice.classList.remove('e-oc-price-pending');
          } else {
            orSizePrice.innerHTML = '&nbsp;';
            orSizePrice.classList.add('e-oc-price-pending');
          }
        });
        orCards.forEach(function (card) {
          var orPriceEl = card.querySelector('.ce-product-hero__vc-price');
          if (orPriceEl) {
            var orCardStyle = card.getAttribute('data-value');
            var orCardSizes = 0;
            if (NONCASE_PRODUCT.data) {
              (NONCASE_PRODUCT.data.variants || []).forEach(function (v) {
                if (v.option1 === orCardStyle && v.available !== false) orCardSizes++;
              });
            }
            if (orCardSizes === 1) {
              orPriceEl.textContent = orPriceEl.textContent.replace(/^\s*From\s+/i, '');
            }
          }
        });
      }
    }

    /* custom bags: the canvas-print pattern (Style visual cards + sparse
       Style x Size sync + HIDDEN unsold sizes + per-size exact prices)
       across the four bag styles. Offer chip differs: the family SPANS
       the $65 free-shipping threshold, so the truthful "Free Shipping"
       chip goes ONLY on style cards whose CHEAPEST live variant clears
       it — derived from the fetched product's own variants, never a
       hardcoded style list. Single-unit family, never a BOGO lockup. */
    if (noun === 'bag') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-bag-hero');
      var bgSel = hero.querySelector('.ce-product-hero__individual-selector');
      var bgCards = bgSel ? bgSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (bgCards.length) {
        if (!hero.__ceBagDefaulted && !bgSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceBagDefaulted = true;
          var bgd = matVariantDisplay(hero);
          var bgDefVal = bgd && bgd.option1 && bgd.option1['default'];
          var bgDefCard = null;
          for (var bgi = 0; bgi < bgCards.length && !bgDefCard; bgi++) {
            if (bgDefVal && bgCards[bgi].getAttribute('data-value') === bgDefVal) bgDefCard = bgCards[bgi];
          }
          if (!bgDefCard) bgDefCard = bgCards[0];
          if (bgDefCard) bgDefCard.click();
        }
        /* style-to-size sync (value-idempotent) + hide unsold sizes */
        fetchNonCaseProduct();
        var bgStyleCard = bgSel.querySelector('.ce-product-hero__visual-card.is-selected[data-option-key="option1"]');
        var bgStyleVal = bgStyleCard && bgStyleCard.getAttribute('data-value');
        var bgProd = NONCASE_PRODUCT.data;
        if (bgStyleVal && bgProd) {
          var bgValidSizes = [];
          (bgProd.variants || []).forEach(function (v) {
            if (v.option1 === bgStyleVal && v.available !== false && bgValidSizes.indexOf(v.option2) === -1) bgValidSizes.push(v.option2);
          });
          if (bgValidSizes.length) {
            var bgSelectedSize = null;
            var bgSizeCardByValue = {};
            bgSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
              var val = card.getAttribute('data-value');
              bgSizeCardByValue[val] = card;
              if (card.classList.contains('is-selected')) bgSelectedSize = val;
              card.style.display = bgValidSizes.indexOf(val) === -1 ? 'none' : '';
            });
            if ((!bgSelectedSize || bgValidSizes.indexOf(bgSelectedSize) === -1) && bgSizeCardByValue[bgValidSizes[0]]) {
              bgSizeCardByValue[bgValidSizes[0]].click();
            }
          }
        }
        /* per-size exact price under the size label */
        bgSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
          var bgSizeVal = card.getAttribute('data-value');
          var bgSizePrice = card.querySelector('.ce-oc-price');
          if (!bgSizePrice) {
            bgSizePrice = document.createElement('div');
            bgSizePrice.className = 'ce-oc-price e-oc-price-pending';
            bgSizePrice.innerHTML = '&nbsp;';
            card.appendChild(bgSizePrice);
          }
          var bgCents = null;
          if (bgProd && bgStyleVal && bgSizeVal) {
            (bgProd.variants || []).forEach(function (v) {
              if (v.option1 === bgStyleVal && v.option2 === bgSizeVal && v.available !== false) bgCents = v.price;
            });
          }
          if (bgCents != null) {
            var bgp = bgCents / 100;
            bgSizePrice.textContent = '$' + (bgp % 1 === 0 ? bgp.toFixed(0) : bgp.toFixed(2));
            bgSizePrice.classList.remove('e-oc-price-pending');
          } else {
            bgSizePrice.innerHTML = '&nbsp;';
            bgSizePrice.classList.add('e-oc-price-pending');
          }
        });
        bgCards.forEach(function (card) {
          /* Style chip above the name (idempotent across re-renders):
             whole-bag thumbnail when the value has one — the rope-cap
             cap-chip pattern. Text-only card is the fallback: no image
             mapped (or a failed load) leaves the card exactly as it
             renders today. */
          var bgChipVal = card.getAttribute('data-value') || '';
          var bgChipImg = BAG_STYLE_IMAGES[bgChipVal];
          var bgNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (bgChipImg && bgNameEl && !card.querySelector('.ce-vc-swatch')) {
            var bgChip = document.createElement('img');
            bgChip.className = 'ce-vc-swatch';
            bgChip.src = bgChipImg;
            bgChip.alt = '';
            bgChip.loading = 'lazy';
            bgChip.width = 48;
            bgChip.height = 48;
            bgChip.style.cssText = 'display:block;width:48px;height:auto;margin:0 auto 4px;border-radius:4px;';
            bgChip.onerror = function () { this.remove(); };
            bgNameEl.insertAdjacentElement('beforebegin', bgChip);
          }
          var bgPriceEl = card.querySelector('.ce-product-hero__vc-price');
          if (bgPriceEl) {
            var bgRight = bgPriceEl.parentNode;
            /* threshold-derived chip: cheapest LIVE variant of this
               style, in cents, from the product's own variants. No
               product JSON yet -> no chip; decorateNonCaseOffer re-runs
               when the fetch resolves. */
            var bgCardStyle = card.getAttribute('data-value');
            var bgMinCents = null;
            if (bgProd && bgCardStyle) {
              (bgProd.variants || []).forEach(function (v) {
                if (v.option1 === bgCardStyle && v.available !== false && (bgMinCents == null || v.price < bgMinCents)) bgMinCents = v.price;
              });
            }
            if (bgMinCents != null && bgMinCents >= 6500 && bgRight && !bgRight.querySelector('.e-tier-offer')) {
              var bgOffer = document.createElement('div');
              bgOffer.className = 'e-tier-offer';
              bgOffer.appendChild(document.createTextNode('Free '));
              var bgShip = document.createElement('b');
              bgShip.className = 'e-tier-offer__free';
              bgShip.innerHTML = 'Shipping' + SQUIGGLE;
              bgOffer.appendChild(bgShip);
              bgRight.appendChild(bgOffer);
            }
          }
        });
        initAmRail(hero, bgSel, bgCards, BAG_FEATURES);
      }
    }

    /* poster: the custom-bags pattern verbatim (Style visual cards +
       sparse Style x Size sync + HIDDEN unsold sizes + per-size exact
       prices + whole-product style chips) across the five poster styles
       (Matte / Satin / Black / Walnut / White Frame). Offer chip: the
       family SPANS the $65 free-shipping threshold (matte $25-45, satin
       $35-60, framed $100-190), so the truthful "Free Shipping" chip
       goes ONLY on style cards whose CHEAPEST live variant clears it —
       derived from the fetched product's own variants, never a hardcoded
       style list (today that is the three frame styles, and a reprice
       changes the chips by itself). Single-unit family, never a BOGO
       lockup. */
    if (noun === 'poster') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-poster-hero');
      var pfSel = hero.querySelector('.ce-product-hero__individual-selector');
      var pfCards = pfSel ? pfSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (pfCards.length) {
        if (!hero.__cePosterDefaulted && !pfSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__cePosterDefaulted = true;
          var pfd = matVariantDisplay(hero);
          var pfDefVal = pfd && pfd.option1 && pfd.option1['default'];
          var pfDefCard = null;
          for (var pfi = 0; pfi < pfCards.length && !pfDefCard; pfi++) {
            if (pfDefVal && pfCards[pfi].getAttribute('data-value') === pfDefVal) pfDefCard = pfCards[pfi];
          }
          if (!pfDefCard) pfDefCard = pfCards[0];
          if (pfDefCard) pfDefCard.click();
        }
        /* style-to-size sync (value-idempotent) + hide unsold sizes:
           framed styles sell 6 sizes, matte/satin sell 10 — a visible
           dead card would read as broken (the canvas rule). */
        fetchNonCaseProduct();
        var pfStyleCard = pfSel.querySelector('.ce-product-hero__visual-card.is-selected[data-option-key="option1"]');
        var pfStyleVal = pfStyleCard && pfStyleCard.getAttribute('data-value');
        var pfProd = NONCASE_PRODUCT.data;
        if (pfStyleVal && pfProd) {
          var pfValidSizes = [];
          (pfProd.variants || []).forEach(function (v) {
            if (v.option1 === pfStyleVal && v.available !== false && pfValidSizes.indexOf(v.option2) === -1) pfValidSizes.push(v.option2);
          });
          if (pfValidSizes.length) {
            var pfSelectedSize = null;
            var pfSizeCardByValue = {};
            pfSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
              var val = card.getAttribute('data-value');
              pfSizeCardByValue[val] = card;
              if (card.classList.contains('is-selected')) pfSelectedSize = val;
              card.style.display = pfValidSizes.indexOf(val) === -1 ? 'none' : '';
            });
            if ((!pfSelectedSize || pfValidSizes.indexOf(pfSelectedSize) === -1) && pfSizeCardByValue[pfValidSizes[0]]) {
              pfSizeCardByValue[pfValidSizes[0]].click();
            }
          }
        }
        /* per-size exact price under the size label */
        pfSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
          var pfSizeVal = card.getAttribute('data-value');
          var pfSizePrice = card.querySelector('.ce-oc-price');
          if (!pfSizePrice) {
            pfSizePrice = document.createElement('div');
            pfSizePrice.className = 'ce-oc-price e-oc-price-pending';
            pfSizePrice.innerHTML = '&nbsp;';
            card.appendChild(pfSizePrice);
          }
          var pfCents = null;
          if (pfProd && pfStyleVal && pfSizeVal) {
            (pfProd.variants || []).forEach(function (v) {
              if (v.option1 === pfStyleVal && v.option2 === pfSizeVal && v.available !== false) pfCents = v.price;
            });
          }
          if (pfCents != null) {
            var pfp = pfCents / 100;
            pfSizePrice.textContent = '$' + (pfp % 1 === 0 ? pfp.toFixed(0) : pfp.toFixed(2));
            pfSizePrice.classList.remove('e-oc-price-pending');
          } else {
            pfSizePrice.innerHTML = '&nbsp;';
            pfSizePrice.classList.add('e-oc-price-pending');
          }
        });
        pfCards.forEach(function (card) {
          /* Style chip above the name (idempotent across re-renders):
             whole-poster thumbnail from the style's own calibrated
             render. Text-only card is the fallback: no image mapped (or
             a failed load) leaves the card exactly as it renders
             today. */
          var pfChipVal = card.getAttribute('data-value') || '';
          var pfChipImg = POSTER_STYLE_IMAGES[pfChipVal];
          var pfNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (pfChipImg && pfNameEl && !card.querySelector('.ce-vc-swatch')) {
            var pfChip = document.createElement('img');
            pfChip.className = 'ce-vc-swatch';
            pfChip.src = pfChipImg;
            pfChip.alt = '';
            pfChip.loading = 'lazy';
            pfChip.width = 48;
            pfChip.height = 48;
            pfChip.style.cssText = 'display:block;width:48px;height:auto;margin:0 auto 4px;border-radius:4px;';
            pfChip.onerror = function () { this.remove(); };
            pfNameEl.insertAdjacentElement('beforebegin', pfChip);
          }
          var pfPriceEl = card.querySelector('.ce-product-hero__vc-price');
          if (pfPriceEl) {
            var pfRight = pfPriceEl.parentNode;
            /* threshold-derived chip: cheapest LIVE variant of this
               style, in cents, from the product's own variants. No
               product JSON yet -> no chip; decorateNonCaseOffer re-runs
               when the fetch resolves. */
            var pfCardStyle = card.getAttribute('data-value');
            var pfMinCents = null;
            if (pfProd && pfCardStyle) {
              (pfProd.variants || []).forEach(function (v) {
                if (v.option1 === pfCardStyle && v.available !== false && (pfMinCents == null || v.price < pfMinCents)) pfMinCents = v.price;
              });
            }
            if (pfMinCents != null && pfMinCents >= 6500 && pfRight && !pfRight.querySelector('.e-tier-offer')) {
              var pfOffer = document.createElement('div');
              pfOffer.className = 'e-tier-offer';
              pfOffer.appendChild(document.createTextNode('Free '));
              var pfShip = document.createElement('b');
              pfShip.className = 'e-tier-offer__free';
              pfShip.innerHTML = 'Shipping' + SQUIGGLE;
              pfOffer.appendChild(pfShip);
              pfRight.appendChild(pfOffer);
            }
          }
        });
        initAmRail(hero, pfSel, pfCards, POSTER_FEATURES);
      }
    }

    /* airpods max case: ONE style card. Same white selected skin as
       boards/rugs; default-select the single card so the CTA is never stuck
       on "Choose Style to Continue" (found on the 2026-07-26 draft PDP
       render); card is titled with the SUPPORTED MODELS from
       variant_display (founder direction 2026-07-27: name the models, not
       "Custom"); features rail above the CTA. NO offer chip: the product
       does not free-ship (store threshold is $65; founder correction
       2026-07-27) and the family is single-unit only. */
    if (noun === 'airpods max case') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-am-hero');
      var amSel = hero.querySelector('.ce-product-hero__individual-selector');
      var amCards = amSel ? amSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (amCards.length) {
        var avd = matVariantDisplay(hero);
        if (!hero.__ceAmDefaulted && !amSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceAmDefaulted = true;
          var aDefVal = avd && avd.option1 && avd.option1['default'];
          var aDefCard = null;
          for (var ad = 0; ad < amCards.length && !aDefCard; ad++) {
            if (aDefVal && amCards[ad].getAttribute('data-value') === aDefVal) aDefCard = amCards[ad];
          }
          if (!aDefCard) aDefCard = amCards[0];
          if (aDefCard) aDefCard.click();
        }
        amCards.forEach(function (card) {
          /* Card title: the variant_display name ("AirPods Max 1st / 2nd
             Gen") instead of the raw option value "Custom" — the plain
             visual_card renderer ignores the configured name. */
          var aVal = card.getAttribute('data-value') || '';
          var aCfg = (avd && avd.option1 && avd.option1.values && avd.option1.values[aVal]) || {};
          var aNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (aNameEl && aCfg.name && aNameEl.textContent !== aCfg.name) {
            aNameEl.textContent = aCfg.name;
          }
          var priceEl = card.querySelector('.ce-product-hero__vc-price');
          if (priceEl) {
            priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
          }
        });
        initAmRail(hero, amSel, amCards);
      }
    }

    /* kindle case: same single-card shape as the airpods max case — ONE
       style card default-selected so the CTA is never stuck on "Choose
       Style to Continue"; card titled with the SUPPORTED MODELS from
       variant_display; features rail above the CTA. NO offer chip: $40 is
       under the store's $65 free-shipping threshold and the family is
       single-unit only. */
    if (noun === 'kindle case') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-am-hero');
      /* Kindle-scoped skin: centers the model-card grid and un-hides the
         per-model fit line the mat skin suppresses (founder direction
         2026-07-28: make what each case supports obvious on the card). */
      hero.classList.add('e-kindle-hero');
      var kSel = hero.querySelector('.ce-product-hero__individual-selector');
      var kCards = kSel ? kSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (kCards.length) {
        var kvd = matVariantDisplay(hero);
        if (!hero.__ceKindleDefaulted && !kSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceKindleDefaulted = true;
          var kDefVal = kvd && kvd.option1 && kvd.option1['default'];
          var kDefCard = null;
          for (var kd = 0; kd < kCards.length && !kDefCard; kd++) {
            if (kDefVal && kCards[kd].getAttribute('data-value') === kDefVal) kDefCard = kCards[kd];
          }
          if (!kDefCard) kDefCard = kCards[0];
          if (kDefCard) kDefCard.click();
        }
        kCards.forEach(function (card) {
          /* Card title: the variant_display name (the short model name)
             instead of the raw option value; the fit line under it comes
             from the variant_display desc — injected here because the
             machinery does not always render vc-desc for visual cards. */
          var kVal = card.getAttribute('data-value') || '';
          var kCfg = (kvd && kvd.option1 && kvd.option1.values && kvd.option1.values[kVal]) || {};
          var kNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (kNameEl && kCfg.name && kNameEl.textContent !== kCfg.name) {
            kNameEl.textContent = kCfg.name;
          }
          if (kCfg.desc) {
            var kDescEl = card.querySelector('.ce-product-hero__vc-desc');
            if (!kDescEl) {
              kDescEl = document.createElement('div');
              kDescEl.className = 'ce-product-hero__vc-desc';
              if (kNameEl) kNameEl.insertAdjacentElement('afterend', kDescEl);
              else card.appendChild(kDescEl);
            }
            if (kDescEl.textContent !== kCfg.desc) kDescEl.textContent = kCfg.desc;
          }
          var priceEl = card.querySelector('.ce-product-hero__vc-price');
          if (priceEl) {
            priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
          }
        });
        initAmRail(hero, kSel, kCards, KINDLE_FEATURES);
      }
    }

    /* macbook case: the kindle shape with FIVE model cards. Same board-hero
       selected-state skin, same default-selection (so the CTA is never stuck
       on "Choose Style to Continue"), same vc-desc injection for the fit line
       the mat skin hides. NO offer chip: $59 is under the store's $65
       free-shipping threshold and the family is single-unit, no BOGO. */
    if (noun === 'macbook case') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-am-hero');
      /* MacBook-scoped skin: 5 cards wrap 3+2, so the grid becomes a
         CENTERED flex wrap (a 3-col grid would leave the second row
         ragged-left) and the per-model fit line is un-hidden. */
      hero.classList.add('e-macbook-hero');
      var mSel = hero.querySelector('.ce-product-hero__individual-selector');
      var mCards = mSel ? mSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (mCards.length) {
        var mvd = matVariantDisplay(hero);
        if (!hero.__ceMacbookDefaulted && !mSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceMacbookDefaulted = true;
          var mDefVal = mvd && mvd.option1 && mvd.option1['default'];
          var mDefCard = null;
          for (var md = 0; md < mCards.length && !mDefCard; md++) {
            if (mDefVal && mCards[md].getAttribute('data-value') === mDefVal) mDefCard = mCards[md];
          }
          if (!mDefCard) mDefCard = mCards[0];
          if (mDefCard) mDefCard.click();
        }
        mCards.forEach(function (card) {
          /* Card title: the variant_display name (the short model name);
             the supported-sizes line under it comes from the desc —
             injected here because the machinery does not render vc-desc
             for visual cards. */
          var mVal = card.getAttribute('data-value') || '';
          var mCfg = (mvd && mvd.option1 && mvd.option1.values && mvd.option1.values[mVal]) || {};
          var mNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (mNameEl && mCfg.name && mNameEl.textContent !== mCfg.name) {
            mNameEl.textContent = mCfg.name;
          }
          if (mCfg.desc) {
            var mDescEl = card.querySelector('.ce-product-hero__vc-desc');
            if (!mDescEl) {
              mDescEl = document.createElement('div');
              mDescEl.className = 'ce-product-hero__vc-desc';
              if (mNameEl) mNameEl.insertAdjacentElement('afterend', mDescEl);
              else card.appendChild(mDescEl);
            }
            if (mDescEl.textContent !== mCfg.desc) mDescEl.textContent = mCfg.desc;
          }
          var priceEl = card.querySelector('.ce-product-hero__vc-price');
          if (priceEl) {
            priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
          }
        });
        initAmRail(hero, mSel, mCards, MACBOOK_FEATURES);
      }
    }

    /* ipad case (tablet folio): the macbook shape with EIGHT model cards.
       Same board-hero selected-state skin, same default-selection (so the
       CTA is never stuck on "Choose Style to Continue"), same vc-desc
       injection for the fit line. NO offer chip: $50-60 sits under the
       store's $65 free-shipping threshold and the family is single-unit,
       no BOGO. */
    if (noun === 'ipad case') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-am-hero');
      hero.classList.add('e-macbook-hero');
      var fSel = hero.querySelector('.ce-product-hero__individual-selector');
      var fCards = fSel ? fSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (fCards.length) {
        var fvd = matVariantDisplay(hero);
        if (!hero.__ceFolioDefaulted && !fSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceFolioDefaulted = true;
          var fDefVal = fvd && fvd.option1 && fvd.option1['default'];
          var fDefCard = null;
          for (var fd = 0; fd < fCards.length && !fDefCard; fd++) {
            if (fDefVal && fCards[fd].getAttribute('data-value') === fDefVal) fDefCard = fCards[fd];
          }
          if (!fDefCard) fDefCard = fCards[0];
          if (fDefCard) fDefCard.click();
        }
        fCards.forEach(function (card) {
          var fVal = card.getAttribute('data-value') || '';
          var fCfg = (fvd && fvd.option1 && fvd.option1.values && fvd.option1.values[fVal]) || {};
          var fNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (fNameEl && fCfg.name && fNameEl.textContent !== fCfg.name) {
            fNameEl.textContent = fCfg.name;
          }
          if (fCfg.desc) {
            var fDescEl = card.querySelector('.ce-product-hero__vc-desc');
            if (!fDescEl) {
              fDescEl = document.createElement('div');
              fDescEl.className = 'ce-product-hero__vc-desc';
              if (fNameEl) fNameEl.insertAdjacentElement('afterend', fDescEl);
              else card.appendChild(fDescEl);
            }
            if (fDescEl.textContent !== fCfg.desc) fDescEl.textContent = fCfg.desc;
          }
          var priceEl = card.querySelector('.ce-product-hero__vc-price');
          if (priceEl) {
            priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
          }
        });
        initAmRail(hero, fSel, fCards, IPAD_FEATURES);
        initIpadFinder(hero, fSel);
      }
    }

    /* rope cap: the macbook shape with EIGHT color cards. Same board-hero
       selected-state skin, same default-selection (so the CTA is never stuck
       on "Choose Color to Continue"), same vc-desc injection for the color
       note. The centered flex wrap (e-macbook-hero) keeps the 4+4 rows tidy.
       NO offer chip: $39 is under the store's $65 free-shipping threshold
       and the family is single-unit, no BOGO. */
    if (noun === 'rope cap') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-am-hero');
      hero.classList.add('e-macbook-hero');
      var rcSel = hero.querySelector('.ce-product-hero__individual-selector');
      var rcCards = rcSel ? rcSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (rcCards.length) {
        var rcvd = matVariantDisplay(hero);
        if (!hero.__ceRopeCapDefaulted && !rcSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceRopeCapDefaulted = true;
          var rcDefVal = rcvd && rcvd.option1 && rcvd.option1['default'];
          var rcDefCard = null;
          for (var rc = 0; rc < rcCards.length && !rcDefCard; rc++) {
            if (rcDefVal && rcCards[rc].getAttribute('data-value') === rcDefVal) rcDefCard = rcCards[rc];
          }
          if (!rcDefCard) rcDefCard = rcCards[0];
          if (rcDefCard) rcDefCard.click();
        }
        rcCards.forEach(function (card) {
          /* Card title: the variant_display name (the color name); the
             tone note under it comes from the desc — injected here because
             the machinery does not render vc-desc for visual cards. */
          var rcVal = card.getAttribute('data-value') || '';
          var rcCfg = (rcvd && rcvd.option1 && rcvd.option1.values && rcvd.option1.values[rcVal]) || {};
          var rcNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (rcNameEl && rcCfg.name && rcNameEl.textContent !== rcCfg.name) {
            rcNameEl.textContent = rcCfg.name;
          }
          /* Colorway chip above the name (idempotent across re-renders):
             cap-photo thumbnail when the value has one, swatch dot fallback. */
          var rcHex = CAP_SWATCHES[rcVal];
          var rcImg = CAP_CHIP_IMAGES[rcVal];
          if ((rcImg || rcHex) && rcNameEl && !card.querySelector('.ce-vc-swatch')) {
            var rcChip;
            if (rcImg) {
              rcChip = document.createElement('img');
              rcChip.className = 'ce-vc-swatch';
              rcChip.src = rcImg + '?width=120';
              rcChip.alt = '';
              rcChip.loading = 'lazy';
              rcChip.width = 48;
              rcChip.height = 36;
              rcChip.style.cssText = 'display:block;width:48px;height:auto;margin:0 auto 4px;';
              if (rcHex) {
                rcChip.onerror = function () {
                  var d = document.createElement('span');
                  d.className = 'ce-vc-swatch';
                  d.setAttribute('aria-hidden', 'true');
                  d.style.cssText = 'display:block;width:16px;height:16px;border-radius:50%;margin:0 auto 6px;background:' + rcHex + ';border:1px solid rgba(18,63,55,.18);box-shadow:inset 0 0 0 1px rgba(255,255,255,.35);';
                  this.replaceWith(d);
                };
              }
            } else {
              rcChip = document.createElement('span');
              rcChip.className = 'ce-vc-swatch';
              rcChip.setAttribute('aria-hidden', 'true');
              rcChip.style.cssText = 'display:block;width:16px;height:16px;border-radius:50%;margin:0 auto 6px;background:' + rcHex + ';border:1px solid rgba(18,63,55,.18);box-shadow:inset 0 0 0 1px rgba(255,255,255,.35);';
            }
            rcNameEl.insertAdjacentElement('beforebegin', rcChip);
          }
          if (rcCfg.desc) {
            var rcDescEl = card.querySelector('.ce-product-hero__vc-desc');
            if (!rcDescEl) {
              rcDescEl = document.createElement('div');
              rcDescEl.className = 'ce-product-hero__vc-desc';
              if (rcNameEl) rcNameEl.insertAdjacentElement('afterend', rcDescEl);
              else card.appendChild(rcDescEl);
            }
            if (rcDescEl.textContent !== rcCfg.desc) rcDescEl.textContent = rcCfg.desc;
          }
          var priceEl = card.querySelector('.ce-product-hero__vc-price');
          if (priceEl) {
            priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
          }
        });
        initAmRail(hero, rcSel, rcCards, CAP_FEATURES);
      }
    }

    /* watch band (relaunch 2026-09-01): two stepped steps. Step 1 = Size
       visual cards (Small / Large) with the fit line from variant_display
       visible ON the card (the mat skin hides vc-desc; the .e-watch-hero
       scope un-hides it, kindle pattern). Step 2 = Hardware Color swatches
       (buckle chips + labels, rendered by the hero's showLabels branch).
       NO default selection on purpose: the size is a fit decision the
       customer makes deliberately, so the CTA stays on "Choose Watch Size
       to Continue" until they pick. Features rail keyed 'default'. BOGO
       product: the cards' bogo pill becomes the FREE lockup via the shared
       decorator above. */
    if (noun === 'watch band') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-am-hero');
      hero.classList.add('e-watch-hero');
      var wbSel = hero.querySelector('.ce-product-hero__individual-selector');
      var wbCards = wbSel ? wbSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (wbCards.length) {
        var wbvd = matVariantDisplay(hero);
        wbCards.forEach(function (card) {
          var wbVal = card.getAttribute('data-value') || '';
          var wbCfg = (wbvd && wbvd.option1 && wbvd.option1.values && wbvd.option1.values[wbVal]) || {};
          var wbNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (wbNameEl && wbCfg.name && wbNameEl.textContent !== wbCfg.name) {
            wbNameEl.textContent = wbCfg.name;
          }
          if (wbCfg.desc) {
            var wbDescEl = card.querySelector('.ce-product-hero__vc-desc');
            if (!wbDescEl) {
              wbDescEl = document.createElement('div');
              wbDescEl.className = 'ce-product-hero__vc-desc';
              if (wbNameEl) wbNameEl.insertAdjacentElement('afterend', wbDescEl);
              else card.appendChild(wbDescEl);
            }
            if (wbDescEl.textContent !== wbCfg.desc) wbDescEl.textContent = wbCfg.desc;
          }
          var wbPriceEl = card.querySelector('.ce-product-hero__vc-price');
          if (wbPriceEl) {
            wbPriceEl.textContent = wbPriceEl.textContent.replace(/^\s*From\s+/i, '');
          }
        });
        initAmRail(hero, wbSel, wbCards, WATCH_FEATURES);
      }
    }

    /* pajama pants: SHAPE-AWARE (family-page pivot 2026-08-01).
       LEGACY (pre-flip): eight size cards on option1, rope-cap shape.
       FAMILY (post-flip): option1 = Style visual cards (Women's / Men's /
       Kids Lounge Pants) + option2 = Size cards with the RUG-pattern
       style-to-size sync (kids sell 4 sizes, adults 8 — the sparse-axis
       auto-click keeps a valid pair selected) and per-size exact price for
       the chosen style. The shape is detected from variant_display
       (option2 present = family), so this deploys DARK before the Style
       axis lands and today's live 1-axis page renders byte-identically.
       Features rail keyed 'default' either way (a value rename can never
       kill it). NO offer chip: single-unit family, no BOGO. */
    if (noun === 'pajama pants') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-am-hero');
      hero.classList.add('e-macbook-hero');
      var pjSel = hero.querySelector('.ce-product-hero__individual-selector');
      var pjCards = pjSel ? pjSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (pjCards.length) {
        var pjvd = matVariantDisplay(hero);
        var pjTwoAxis = !!(pjvd && pjvd.option2);
        if (!hero.__cePajamaDefaulted && !pjSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__cePajamaDefaulted = true;
          var pjDefVal = pjvd && pjvd.option1 && pjvd.option1['default'];
          var pjDefCard = null;
          for (var pj = 0; pj < pjCards.length && !pjDefCard; pj++) {
            if (pjDefVal && pjCards[pj].getAttribute('data-value') === pjDefVal) pjDefCard = pjCards[pj];
          }
          if (!pjDefCard) pjDefCard = pjCards[0];
          if (pjDefCard) pjDefCard.click();
        }
        pjCards.forEach(function (card) {
          var pjVal = card.getAttribute('data-value') || '';
          var pjCfg = (pjvd && pjvd.option1 && pjvd.option1.values && pjvd.option1.values[pjVal]) || {};
          var pjNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (pjNameEl && pjCfg.name && pjNameEl.textContent !== pjCfg.name) {
            pjNameEl.textContent = pjCfg.name;
          }
          if (pjCfg.desc) {
            var pjDescEl = card.querySelector('.ce-product-hero__vc-desc');
            if (!pjDescEl) {
              pjDescEl = document.createElement('div');
              pjDescEl.className = 'ce-product-hero__vc-desc';
              if (pjNameEl) pjNameEl.insertAdjacentElement('afterend', pjDescEl);
              else card.appendChild(pjDescEl);
            }
            if (pjDescEl.textContent !== pjCfg.desc) pjDescEl.textContent = pjCfg.desc;
            /* founder 2026-08-01: descs carry a deliberate 
 ("Sizes" /
               "XS-4XL", "Lounge Pants" / "XS-L") so all three style cards
               render two desc lines at equal height. */
            pjDescEl.style.whiteSpace = 'pre-line';
          }
          var pjPriceEl = card.querySelector('.ce-product-hero__vc-price');
          if (pjPriceEl && !pjTwoAxis) {
            /* legacy 1-axis: every card is one exact-price variant */
            pjPriceEl.textContent = pjPriceEl.textContent.replace(/^\s*From\s+/i, '');
          }
        });
        if (pjTwoAxis) {
          /* style-to-size sync + per-size price, the rug worked example */
          fetchNonCaseProduct();
          var pjStyleCard = pjSel.querySelector('.ce-product-hero__visual-card.is-selected[data-option-key="option1"]');
          var pjStyleVal = pjStyleCard && pjStyleCard.getAttribute('data-value');
          var pjProd = NONCASE_PRODUCT.data;
          if (pjStyleVal && pjProd) {
            var pjValidSizes = [];
            (pjProd.variants || []).forEach(function (v) {
              if (v.option1 === pjStyleVal && v.available !== false && pjValidSizes.indexOf(v.option2) === -1) pjValidSizes.push(v.option2);
            });
            if (pjValidSizes.length) {
              var pjSelectedSize = null;
              var pjSizeCardByValue = {};
              pjSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
                var val = card.getAttribute('data-value');
                pjSizeCardByValue[val] = card;
                if (card.classList.contains('is-selected')) pjSelectedSize = val;
                /* kids sell XS-L only: hide sizes the chosen style never sells
                   (display-only; the machinery still owns selection state) */
                card.style.display = pjValidSizes.indexOf(val) === -1 ? 'none' : '';
              });
              if ((!pjSelectedSize || pjValidSizes.indexOf(pjSelectedSize) === -1) && pjSizeCardByValue[pjValidSizes[0]]) {
                pjSizeCardByValue[pjValidSizes[0]].click();
              }
            }
          }
          pjSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
            var pjSizeVal = card.getAttribute('data-value');
            var pjSizePrice = card.querySelector('.ce-oc-price');
            if (!pjSizePrice) {
              pjSizePrice = document.createElement('div');
              pjSizePrice.className = 'ce-oc-price e-oc-price-pending';
              pjSizePrice.innerHTML = '&nbsp;';
              card.appendChild(pjSizePrice);
            }
            var pjCents = null;
            if (pjProd && pjStyleVal && pjSizeVal) {
              (pjProd.variants || []).forEach(function (v) {
                if (v.option1 === pjStyleVal && v.option2 === pjSizeVal && v.available !== false) pjCents = v.price;
              });
            }
            if (pjCents != null) {
              var pjp = pjCents / 100;
              pjSizePrice.textContent = '$' + (pjp % 1 === 0 ? pjp.toFixed(0) : pjp.toFixed(2));
              pjSizePrice.classList.remove('e-oc-price-pending');
            } else {
              pjSizePrice.innerHTML = '&nbsp;';
              pjSizePrice.classList.add('e-oc-price-pending');
            }
          });
        }
        initAmRail(hero, pjSel, pjCards, PJ_FEATURES);
      }
    }

    /* shirt: the pajama two-axis shape with the rope cap's photo chips.
       option1 = Color visual cards (8 colorways, chip = the colorway's own
       calibrated blank-front photo, swatch dot fallback), option2 = Size
       cards with the sparse-combo sync (XS sells in White/Black only, 4XL in
       White only, Dark Grey Heather has no 2XL — hide sizes the chosen color
       never sells and keep a valid pair selected). Features rail keyed
       'default'. NO offer chip: $29.99 single-unit family, no BOGO, under
       the $65 sitewide free-shipping threshold. */
    if (noun === 'shirt' || noun === 'hoodie' || noun === 'zip-up hoodie') {
      var apSwatches = noun === 'hoodie' ? HOODIE_SWATCHES : noun === 'zip-up hoodie' ? ZIP_HOODIE_SWATCHES : SHIRT_SWATCHES;
      var apChips = noun === 'hoodie' ? HOODIE_CHIP_IMAGES : noun === 'zip-up hoodie' ? ZIP_HOODIE_CHIP_IMAGES : SHIRT_CHIP_IMAGES;
      var apFeatures = noun === 'hoodie' ? HOODIE_FEATURES : noun === 'zip-up hoodie' ? ZIP_HOODIE_FEATURES : SHIRT_FEATURES;
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-am-hero');
      hero.classList.add('e-macbook-hero');
      var shSel = hero.querySelector('.ce-product-hero__individual-selector');
      /* Color controls may render as visual cards OR compact swatches
         (variant_display option1.type "swatch", 2026-08-07) — the branches
         below key off data-option-key/data-value, which both carry. */
      var shCards = shSel
        ? shSel.querySelectorAll(
            '.ce-product-hero__visual-card[data-option-key="option1"], .ce-product-hero__option-swatch[data-option-key="option1"]'
          )
        : [];
      if (shCards.length) {
        var shvd = matVariantDisplay(hero);
        if (!hero.__ceShirtDefaulted && !shSel.querySelector('.ce-product-hero__visual-card.is-selected, .ce-product-hero__option-swatch.is-selected')) {
          hero.__ceShirtDefaulted = true;
          var shDefVal = shvd && shvd.option1 && shvd.option1['default'];
          var shDefCard = null;
          for (var sh = 0; sh < shCards.length && !shDefCard; sh++) {
            if (shDefVal && shCards[sh].getAttribute('data-value') === shDefVal) shDefCard = shCards[sh];
          }
          if (!shDefCard) shDefCard = shCards[0];
          if (shDefCard) shDefCard.click();
        }
        shCards.forEach(function (card) {
          /* Swatch buttons ARE the chip — no name/desc/chip injection. */
          if (card.classList.contains('ce-product-hero__option-swatch')) return;
          var shVal = card.getAttribute('data-value') || '';
          var shCfg = (shvd && shvd.option1 && shvd.option1.values && shvd.option1.values[shVal]) || {};
          var shNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (shNameEl && shCfg.name && shNameEl.textContent !== shCfg.name) {
            shNameEl.textContent = shCfg.name;
          }
          /* Colorway chip above the name (idempotent across re-renders):
             shirt-photo thumbnail with a swatch-dot error fallback. */
          var shHex = apSwatches[shVal];
          var shImg = apChips[shVal];
          if ((shImg || shHex) && shNameEl && !card.querySelector('.ce-vc-swatch')) {
            var shChip;
            if (shImg) {
              shChip = document.createElement('img');
              shChip.className = 'ce-vc-swatch';
              shChip.src = shImg;
              shChip.alt = '';
              shChip.loading = 'lazy';
              shChip.width = 48;
              shChip.height = 36;
              shChip.style.cssText = 'display:block;width:48px;height:auto;margin:0 auto 4px;border-radius:4px;';
              if (shHex) {
                shChip.onerror = function () {
                  var d = document.createElement('span');
                  d.className = 'ce-vc-swatch';
                  d.setAttribute('aria-hidden', 'true');
                  d.style.cssText = 'display:block;width:16px;height:16px;border-radius:50%;margin:0 auto 6px;background:' + shHex + ';border:1px solid rgba(18,63,55,.18);box-shadow:inset 0 0 0 1px rgba(255,255,255,.35);';
                  this.replaceWith(d);
                };
              }
            } else {
              shChip = document.createElement('span');
              shChip.className = 'ce-vc-swatch';
              shChip.setAttribute('aria-hidden', 'true');
              shChip.style.cssText = 'display:block;width:16px;height:16px;border-radius:50%;margin:0 auto 6px;background:' + shHex + ';border:1px solid rgba(18,63,55,.18);box-shadow:inset 0 0 0 1px rgba(255,255,255,.35);';
            }
            shNameEl.insertAdjacentElement('beforebegin', shChip);
          }
          if (shCfg.desc) {
            var shDescEl = card.querySelector('.ce-product-hero__vc-desc');
            if (!shDescEl) {
              shDescEl = document.createElement('div');
              shDescEl.className = 'ce-product-hero__vc-desc';
              if (shNameEl) shNameEl.insertAdjacentElement('afterend', shDescEl);
              else card.appendChild(shDescEl);
            }
            if (shDescEl.textContent !== shCfg.desc) shDescEl.textContent = shCfg.desc;
          }
        });
        /* color-to-size sync + per-size exact price (pajama family pattern) */
        fetchNonCaseProduct();
        var shColorCard = shSel.querySelector(
          '.ce-product-hero__visual-card.is-selected[data-option-key="option1"], .ce-product-hero__option-swatch.is-selected[data-option-key="option1"]'
        );
        var shColorVal = shColorCard && shColorCard.getAttribute('data-value');
        var shProd = NONCASE_PRODUCT.data;
        if (shColorVal && shProd) {
          var shValidSizes = [];
          (shProd.variants || []).forEach(function (v) {
            if (v.option1 === shColorVal && v.available !== false && shValidSizes.indexOf(v.option2) === -1) shValidSizes.push(v.option2);
          });
          if (shValidSizes.length) {
            var shSelectedSize = null;
            var shSizeCardByValue = {};
            shSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
              var val = card.getAttribute('data-value');
              shSizeCardByValue[val] = card;
              if (card.classList.contains('is-selected')) shSelectedSize = val;
              card.style.display = shValidSizes.indexOf(val) === -1 ? 'none' : '';
            });
            if (!shSelectedSize || shValidSizes.indexOf(shSelectedSize) === -1) {
              /* Prefer the variant_display default (M) whenever the chosen
                 color sells it; first valid size only as the sparse-combo
                 fallback. Without this the sync races the machinery's own
                 default click and lands every session on XS (E2E catch,
                 2026-08-05). */
              var shDefSize = shvd && shvd.option2 && shvd.option2['default'];
              var shPick = shDefSize && shValidSizes.indexOf(shDefSize) !== -1 ? shDefSize : shValidSizes[0];
              if (shSizeCardByValue[shPick]) shSizeCardByValue[shPick].click();
            }
          }
        }
        shSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
          var shSizeVal = card.getAttribute('data-value');
          var shSizePrice = card.querySelector('.ce-oc-price');
          if (!shSizePrice) {
            shSizePrice = document.createElement('div');
            shSizePrice.className = 'ce-oc-price e-oc-price-pending';
            shSizePrice.innerHTML = '&nbsp;';
            card.appendChild(shSizePrice);
          }
          var shCents = null;
          if (shProd && shColorVal && shSizeVal) {
            (shProd.variants || []).forEach(function (v) {
              if (v.option1 === shColorVal && v.option2 === shSizeVal && v.available !== false) shCents = v.price;
            });
          }
          if (shCents != null) {
            var shp = shCents / 100;
            shSizePrice.textContent = '$' + (shp % 1 === 0 ? shp.toFixed(0) : shp.toFixed(2));
            shSizePrice.classList.remove('e-oc-price-pending');
          } else {
            shSizePrice.innerHTML = '&nbsp;';
            shSizePrice.classList.add('e-oc-price-pending');
          }
        });
        initAmRail(hero, shSel, shCards, apFeatures);
      }
    }

    /* ================= Baby & Kids wave (2026-09-08) ================= */

    /* Both bodysuits: Color x Size on the shirt/pajama two-axis shape,
       WITHOUT the colorway chip maps (the wave launches before its
       calibrated per-color photos exist, and an unmapped card renders
       exactly as the theme already draws it). Sparse Color x Size combos
       are hidden and a valid pair stays selected; each size card shows its
       own exact price read from the product's own variants. The rail rows
       split on the title: the snap bodysuit prints front AND back, the
       long-legged one-piece prints the front only. */
    if (noun === 'bodysuit') {
      var bsFeatures = /long-legged/i.test(title) ? BODYSUIT_LONG_FEATURES : BODYSUIT_FEATURES;
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-am-hero');
      hero.classList.add('e-macbook-hero');
      var bsSel = hero.querySelector('.ce-product-hero__individual-selector');
      var bsCards = bsSel
        ? bsSel.querySelectorAll(
            '.ce-product-hero__visual-card[data-option-key="option1"], .ce-product-hero__option-swatch[data-option-key="option1"]'
          )
        : [];
      if (bsCards.length) {
        var bsvd = matVariantDisplay(hero);
        if (!hero.__ceBodysuitDefaulted && !bsSel.querySelector('.ce-product-hero__visual-card.is-selected, .ce-product-hero__option-swatch.is-selected')) {
          hero.__ceBodysuitDefaulted = true;
          var bsDefVal = bsvd && bsvd.option1 && bsvd.option1['default'];
          var bsDefCard = null;
          for (var bs = 0; bs < bsCards.length && !bsDefCard; bs++) {
            if (bsDefVal && bsCards[bs].getAttribute('data-value') === bsDefVal) bsDefCard = bsCards[bs];
          }
          if (!bsDefCard) bsDefCard = bsCards[0];
          if (bsDefCard) bsDefCard.click();
        }
        bsCards.forEach(function (card) {
          /* Swatch buttons ARE the chip — no name/desc injection. */
          if (card.classList.contains('ce-product-hero__option-swatch')) return;
          var bsVal = card.getAttribute('data-value') || '';
          var bsCfg = (bsvd && bsvd.option1 && bsvd.option1.values && bsvd.option1.values[bsVal]) || {};
          var bsNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (bsNameEl && bsCfg.name && bsNameEl.textContent !== bsCfg.name) {
            bsNameEl.textContent = bsCfg.name;
          }
          if (bsCfg.desc) {
            var bsDescEl = card.querySelector('.ce-product-hero__vc-desc');
            if (!bsDescEl) {
              bsDescEl = document.createElement('div');
              bsDescEl.className = 'ce-product-hero__vc-desc';
              if (bsNameEl) bsNameEl.insertAdjacentElement('afterend', bsDescEl);
              else card.appendChild(bsDescEl);
            }
            if (bsDescEl.textContent !== bsCfg.desc) bsDescEl.textContent = bsCfg.desc;
          }
        });
        /* color-to-size sync + per-size exact price (the shirt worked example) */
        fetchNonCaseProduct();
        var bsColorCard = bsSel.querySelector(
          '.ce-product-hero__visual-card.is-selected[data-option-key="option1"], .ce-product-hero__option-swatch.is-selected[data-option-key="option1"]'
        );
        var bsColorVal = bsColorCard && bsColorCard.getAttribute('data-value');
        var bsProd = NONCASE_PRODUCT.data;
        if (bsColorVal && bsProd) {
          var bsValidSizes = [];
          (bsProd.variants || []).forEach(function (v) {
            if (v.option1 === bsColorVal && v.available !== false && bsValidSizes.indexOf(v.option2) === -1) bsValidSizes.push(v.option2);
          });
          if (bsValidSizes.length) {
            var bsSelectedSize = null;
            var bsSizeCardByValue = {};
            bsSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
              var val = card.getAttribute('data-value');
              bsSizeCardByValue[val] = card;
              if (card.classList.contains('is-selected')) bsSelectedSize = val;
              card.style.display = bsValidSizes.indexOf(val) === -1 ? 'none' : '';
            });
            if (!bsSelectedSize || bsValidSizes.indexOf(bsSelectedSize) === -1) {
              /* Prefer the variant_display default whenever the chosen color
                 sells it; the first valid size is the sparse-combo fallback
                 only (the 2026-08-05 shirt race, which landed every session
                 on the smallest size). */
              var bsDefSize = bsvd && bsvd.option2 && bsvd.option2['default'];
              var bsPick = bsDefSize && bsValidSizes.indexOf(bsDefSize) !== -1 ? bsDefSize : bsValidSizes[0];
              if (bsSizeCardByValue[bsPick]) bsSizeCardByValue[bsPick].click();
            }
          }
        }
        bsSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
          var bsSizeVal = card.getAttribute('data-value');
          var bsSizePrice = card.querySelector('.ce-oc-price');
          if (!bsSizePrice) {
            bsSizePrice = document.createElement('div');
            bsSizePrice.className = 'ce-oc-price e-oc-price-pending';
            bsSizePrice.innerHTML = '&nbsp;';
            card.appendChild(bsSizePrice);
          }
          var bsCents = null;
          if (bsProd && bsColorVal && bsSizeVal) {
            (bsProd.variants || []).forEach(function (v) {
              if (v.option1 === bsColorVal && v.option2 === bsSizeVal && v.available !== false) bsCents = v.price;
            });
          }
          if (bsCents != null) {
            var bsp = bsCents / 100;
            bsSizePrice.textContent = '$' + (bsp % 1 === 0 ? bsp.toFixed(0) : bsp.toFixed(2));
            bsSizePrice.classList.remove('e-oc-price-pending');
          } else {
            bsSizePrice.innerHTML = '&nbsp;';
            bsSizePrice.classList.add('e-oc-price-pending');
          }
        });
        initAmRail(hero, bsSel, bsCards, bsFeatures);
      }
    }

    /* The six one-size nouns and the two-style hooded towel take the shared
       single-axis shape (see initBabySingleAxis). One branch per noun so a
       noun can diverge later without disturbing its siblings. */
    if (noun === 'beanie') {
      initBabySingleAxis(hero, BEANIE_FEATURES, '__ceBeanieDefaulted');
    }
    if (noun === 'swaddle blanket') {
      initBabySingleAxis(hero, SWADDLE_FEATURES, '__ceSwaddleDefaulted');
    }
    if (noun === 'lovey blanket') {
      initBabySingleAxis(hero, LOVEY_FEATURES, '__ceLoveyDefaulted');
    }
    if (noun === 'crib sheet') {
      initBabySingleAxis(hero, CRIB_SHEET_FEATURES, '__ceCribSheetDefaulted');
    }
    if (noun === 'changing pad cover') {
      initBabySingleAxis(hero, CHANGING_PAD_FEATURES, '__ceChangingPadDefaulted');
    }
    if (noun === 'nursing pillow cover') {
      initBabySingleAxis(hero, NURSING_PILLOW_FEATURES, '__ceNursingPillowDefaulted');
    }
    if (noun === 'hooded towel') {
      initBabySingleAxis(hero, HOODED_TOWEL_FEATURES, '__ceHoodedTowelDefaulted');
    }

    /* Custom mugs family (relaunch 2026-08-09): swatch dots on the color
       cards (founder ask: SHOW the colors during selection), per-size exact
       prices, and the features rail above the CTA. One branch serves all
       three products; the rail rows split by product title. */
    if (noun === 'mug') {
      var mgFeatures = /color changing|morphing/i.test(title)
        ? MUG_MORPH_FEATURES
        : /accent/i.test(title)
          ? MUG_ACCENT_FEATURES
          : MUG_CERAMIC_FEATURES;
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-am-hero');
      var mgSel = hero.querySelector('.ce-product-hero__individual-selector');
      if (mgSel) {
        var mgCards = mgSel.querySelectorAll(
          '.ce-product-hero__visual-card[data-option-key="option1"], .ce-product-hero__option-swatch[data-option-key="option1"]'
        );
        mgCards.forEach(function (card) {
          /* Swatch buttons ARE the chip — no dot injection. */
          if (card.classList.contains('ce-product-hero__option-swatch')) return;
          var mgVal = card.getAttribute('data-value') || '';
          var mgHex = MUG_SWATCHES[mgVal];
          var mgNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (mgHex && mgNameEl && !card.querySelector('.ce-vc-swatch')) {
            var mgDot = document.createElement('span');
            mgDot.className = 'ce-vc-swatch';
            mgDot.setAttribute('aria-hidden', 'true');
            mgDot.style.cssText = 'display:block;width:16px;height:16px;border-radius:50%;margin:0 auto 6px;background:' + mgHex + ';border:1px solid rgba(18,63,55,.18);box-shadow:inset 0 0 0 1px rgba(255,255,255,.35);';
            mgNameEl.insertAdjacentElement('beforebegin', mgDot);
          }
        });
        /* Per-size exact price on the Size cards (White/Black and 11/15oz
           differ; the shirt-family pattern). */
        fetchNonCaseProduct();
        var mgColorCard = mgSel.querySelector(
          '.ce-product-hero__visual-card.is-selected[data-option-key="option1"], .ce-product-hero__option-swatch.is-selected[data-option-key="option1"]'
        );
        var mgColorVal = mgColorCard && mgColorCard.getAttribute('data-value');
        var mgProd = NONCASE_PRODUCT.data;
        mgSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
          var mgSizeVal = card.getAttribute('data-value');
          var mgPrice = card.querySelector('.ce-oc-price');
          if (!mgPrice) {
            mgPrice = document.createElement('div');
            mgPrice.className = 'ce-oc-price e-oc-price-pending';
            mgPrice.innerHTML = '&nbsp;';
            card.appendChild(mgPrice);
          }
          var mgCents = null;
          if (mgProd && mgColorVal && mgSizeVal) {
            (mgProd.variants || []).forEach(function (v) {
              if (v.option1 === mgColorVal && v.option2 === mgSizeVal && v.available !== false) mgCents = v.price;
            });
          }
          if (mgCents != null) {
            var mgp = mgCents / 100;
            mgPrice.textContent = '$' + (mgp % 1 === 0 ? mgp.toFixed(0) : mgp.toFixed(2));
            mgPrice.classList.remove('e-oc-price-pending');
          } else {
            mgPrice.innerHTML = '&nbsp;';
            mgPrice.classList.add('e-oc-price-pending');
          }
        });
        /* Rail cards: the color cards where they exist (ceramic/accent);
           the morph's single Size card otherwise (kindle pattern). */
        var mgRailCards = mgCards.length
          ? mgCards
          : mgSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option1"]');
        initAmRail(hero, mgSel, mgRailCards, mgFeatures);
      }
    }

    /* option-card price slot: reserve the height from first render so
       the machinery's re-render (which adds .ce-oc-price once a prior
       option is picked) can't grow the card and shift the page. Grids
       that never receive a price just keep an invisible line — equal
       card heights either way. */
    hero.querySelectorAll('.ce-product-hero__option-card').forEach(function (card) {
      if (card.querySelector('.ce-oc-price')) return;
      var ph = document.createElement('div');
      ph.className = 'ce-oc-price e-oc-price-pending';
      ph.innerHTML = '&nbsp;';
      card.appendChild(ph);
    });
  }
  function elevateAssetBase() {
    if (window.ceElevateAssetBase) return window.ceElevateAssetBase;
    var s = document.querySelector('script[src*="ce-elevate.js"]');
    return s ? s.src.split('ce-elevate.js')[0] : '';
  }
  function tierCardName(card) {
    var el = card.querySelector('.ce-product-hero__tier-card-name');
    return el ? el.textContent.trim() : '';
  }

  /* Only decorate where the elevate PDP skin is actually loaded. It ships
     via ce-keepsake-pdp-skin (which renders .ce-keepsake-section);
     ce-noncustom-hero is a class-identical clone that loads no skin, so
     without this gate its cards would sprout an unstyled rail. */
  function tierSkinOn() {
    return !!document.querySelector('.ce-keepsake-section');
  }

  /* Find the recommended (badged) card in a wrap, or null. */
  function recommendedCard(wrap) {
    var cards = wrap.querySelectorAll('.ce-product-hero__tier-card');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].querySelector('.ce-product-hero__tier-card-badge')) return cards[i];
    }
    return null;
  }

  /* Chip: wrap the photo so the drop pill can ride inside it. */
  function initTierChips() {
    if (!tierSkinOn()) return;
    document.querySelectorAll('.ce-product-hero__tier-wrap').forEach(function (wrap) {
      /* Show the recommended style as selected by default. The machinery
         only marks a card .active once a phone model is chosen (preselect
         fires in setModel), so before that nothing reads as picked. When
         no card is active yet, default the selection to the recommended
         card — the same card preselect resolves to, so the two never
         disagree and this yields to the real selection the moment it lands. */
      if (!wrap.querySelector('.ce-product-hero__tier-card.active')) {
        var rec = recommendedCard(wrap);
        if (rec) rec.classList.add('active');
      }
      wrap.querySelectorAll('.ce-product-hero__tier-card').forEach(function (card) {
        /* the machinery sets role/tabindex/aria-label but never says which
           card is chosen */
        card.setAttribute('aria-pressed', card.classList.contains('active') ? 'true' : 'false');
        if (card.querySelector('.e-tier-shot')) return;
        var img = card.querySelector('.ce-product-hero__tier-card-img');
        if (!img) return;
        var shot = document.createElement('div');
        shot.className = 'e-tier-shot';
        img.parentNode.insertBefore(shot, img);
        shot.appendChild(img);
        var spec = TIER_SPEC[tierCardName(card)];
        if (!spec) return;
        var pill = document.createElement('span');
        pill.className = 'e-tier-drop';
        pill.textContent = spec.drop;
        shot.appendChild(pill);
      });
    });
  }

  /* One rail per selector, inserted OUTSIDE the grid the machinery wipes
     (renderCaseTypes does tierGrid.innerHTML = ''), so it is created once
     and only ever has its contents rewritten. */
  function initTierRail() {
    if (!tierSkinOn()) return;
    document.querySelectorAll('.ce-product-hero__tier-wrap').forEach(function (wrap) {
      var cards = wrap.querySelectorAll('.ce-product-hero__tier-card');
      if (!cards.length) return;

      /* Before a model is picked nothing is .active — fall back to the
         recommended card so the rail is populated from first paint and
         never shifts when the preselect lands. */
      var active = wrap.querySelector('.ce-product-hero__tier-card.active');
      if (!active) {
        for (var i = 0; i < cards.length; i++) {
          if (cards[i].querySelector('.ce-product-hero__tier-card-badge')) { active = cards[i]; break; }
        }
      }
      if (!active) active = cards[0];

      var name = tierCardName(active);
      var spec = TIER_SPEC[name];
      if (!spec) return; /* non-case hero (mats, blankets) — leave alone */

      var rail = wrap.nextElementSibling;
      if (!rail || !rail.classList.contains('e-tier-rail')) {
        rail = document.createElement('div');
        rail.className = 'e-tier-rail';
        rail.setAttribute('aria-live', 'polite');
        rail.setAttribute('aria-atomic', 'true');
        wrap.insertAdjacentElement('afterend', rail);
      }
      /* the retry ladder + every state change call this; without the guard
         the rail would re-animate on each no-op pass */
      if (rail.__ceTier === name) return;
      rail.__ceTier = name;

      var base = elevateAssetBase();
      rail.innerHTML = '';

      var sr = document.createElement('span');
      sr.className = 'visually-hidden';
      sr.textContent = name + ' includes';
      rail.appendChild(sr);

      var head = document.createElement('div');
      head.className = 'e-tier-rail__head';
      var nm = document.createElement('span');
      nm.className = 'e-tier-rail__name';
      nm.textContent = name;
      head.appendChild(nm);
      var spectrum = document.querySelector('.ce-protection');
      if (spectrum) {
        var cmp = document.createElement('button');
        cmp.type = 'button';
        cmp.className = 'e-tier-rail__compare';
        cmp.textContent = 'Compare all styles →';
        cmp.addEventListener('click', function () {
          spectrum.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        head.appendChild(cmp);
      }
      rail.appendChild(head);

      var ul = document.createElement('ul');
      ul.className = 'e-tier-rail__items';
      spec.rows.forEach(function (row, i) {
        var li = document.createElement('li');
        li.style.setProperty('--e-rail-i', i);
        /* the finish switch finds the print row by this */
        li.setAttribute('data-e-row', row[0]);
        var icon = document.createElement('img');
        icon.className = 'e-tier-rail__icon';
        icon.src = base + 'icon-usp-' + row[0] + '.png';
        icon.alt = '';
        icon.setAttribute('aria-hidden', 'true');
        icon.width = 12;
        icon.height = 12;
        icon.loading = 'lazy';
        li.appendChild(icon);
        var label = document.createElement('span');
        label.className = 'e-tier-rail__label';
        label.textContent = row[1];
        li.appendChild(label);
        ul.appendChild(li);
      });
      rail.appendChild(ul);

      /* animate in only — fading out first would cost a round-trip and
         read as lag on tap */
      rail.classList.remove('is-in');
      requestAnimationFrame(function () { rail.classList.add('is-in'); });
    });
  }

  /* The machinery's own (skin-hidden) finish card for a finish, or null.
     Live option values are lowercase; compare case-blind anyway. */
  function finishCard(hero, finish) {
    var cards = hero.querySelectorAll('.ce-product-hero__finish-card');
    for (var i = 0; i < cards.length; i++) {
      if ((cards[i].getAttribute('data-finish') || '').toLowerCase() === finish) return cards[i];
    }
    return null;
  }

  /* Finish switch (Matt, 2026-10-13). The Select Finish step stays retired
     and every case still starts glossy, but matte has loyal buyers, so it
     comes back as a quiet link instead of a decision: where the selected
     phone + case really sells both finishes, the rail's "Glossy HD Print"
     row carries "Switch to matte"; one tap and it reads "Matte HD Print"
     with "Switch to glossy". No step label, no cards, the CTA never waits
     on it, and a case with one finish keeps the plain row.

     The switch only clicks the machinery's own hidden finish card, so
     state, variant id and events stay canonical (the matte variant is what
     the customizer and the order carry). The shopper's pick is remembered
     on the hero for the visit: re-picking a phone or case that sells matte
     lands on matte again, and decorateFreePricing's glossy guard stands
     down for it. Idempotent; the button node is kept across state changes
     so keyboard focus survives the tap. */
  function initFinishSwitch() {
    if (!tierSkinOn()) return;
    document.querySelectorAll('.ce-product-hero__tier-wrap').forEach(function (wrap) {
      var rail = wrap.nextElementSibling;
      var hero = wrap.closest('.ce-product-hero');
      if (!hero || !rail || !rail.classList.contains('e-tier-rail')) return;
      var row = rail.querySelector('.e-tier-rail__items li[data-e-row="print"]');
      var label = row && row.querySelector('.e-tier-rail__label');
      if (!label) return;
      if (!label.hasAttribute('data-e-base')) label.setAttribute('data-e-base', label.textContent);
      var base = label.getAttribute('data-e-base');
      var sep = row.querySelector('.e-tier-rail__sep');
      var btn = row.querySelector('.e-tier-rail__finish');

      var glossy = finishCard(hero, 'glossy');
      var matte = finishCard(hero, 'matte');
      /* the rail can show a case the machinery has not selected yet (the
         recommended card before a phone is picked): no cards, no switch */
      if (!glossy || !matte || !/^Glossy\b/.test(base)) {
        if (sep) sep.remove();
        if (btn) btn.remove();
        row.classList.remove('is-matte');
        if (label.textContent !== base) label.textContent = base;
        return;
      }

      if (hero.__ceFinishPick === 'matte' && !matte.classList.contains('active')) {
        /* re-enters through ce:state-change with matte active; this pass
           then only repaints */
        matte.click();
      }
      var isMatte = matte.classList.contains('active');

      if (!btn) {
        sep = document.createElement('span');
        sep.className = 'e-tier-rail__sep';
        sep.setAttribute('aria-hidden', 'true');
        sep.textContent = '·';
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'e-tier-rail__finish';
        btn.addEventListener('click', function () {
          var toMatte = !row.classList.contains('is-matte');
          var target = finishCard(hero, toMatte ? 'matte' : 'glossy');
          if (!target) return;
          hero.__ceFinishPick = toMatte ? 'matte' : 'glossy';
          target.click();
        });
        row.appendChild(sep);
        row.appendChild(btn);
      }
      var text = isMatte ? base.replace(/^Glossy\b/, 'Matte') : base;
      var action = isMatte ? 'Switch to glossy' : 'Switch to matte';
      row.classList.toggle('is-matte', isMatte);
      if (label.textContent !== text) label.textContent = text;
      if (btn.textContent !== action) btn.textContent = action;
    });
  }

  /* Arm once: note that the pending select came from the keyboard. Never
     calls preventDefault/stopPropagation, so it cannot swallow the
     machinery's own activation. */
  function initTierRestore() {
    document.querySelectorAll('.ce-product-hero__tier-wrap').forEach(function (wrap) {
      if (wrap.__ceRestoreArmed) return;
      wrap.__ceRestoreArmed = true;
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { wrap.__ceKbd = true; }
      }, true);
    });
  }

  /* Repair what the innerHTML wipe destroys on every select:
     - scrollLeft collapses to 0, so tapping tier 4 scrolls your own pick
       off screen (only visible once the row actually overflows)
     - the focused card is deleted, dropping focus to <body> (a WCAG fail) */
  function restoreTierState() {
    document.querySelectorAll('.ce-product-hero__tier-wrap').forEach(function (wrap) {
      var grid = wrap.querySelector('.ce-product-hero__tier-grid');
      var active = wrap.querySelector('.ce-product-hero__tier-card.active');
      if (!grid || !active) return;
      if (grid.scrollWidth > grid.clientWidth + 8) {
        /* Sideways ONLY. scrollIntoView also scrolls every ancestor on the
           block axis, so on a phone (where the row overflows) the preselected
           "Most Popular" card dragged the whole PAGE down about 290 px roughly
           a second after load, for every first-time visitor. Move the row's
           own scrollLeft instead; the page never moves. */
        var gridBox = grid.getBoundingClientRect();
        var cardBox = active.getBoundingClientRect();
        if (cardBox.left < gridBox.left) {
          grid.scrollLeft += cardBox.left - gridBox.left - 8;
        } else if (cardBox.right > gridBox.right) {
          grid.scrollLeft += cardBox.right - gridBox.right + 8;
        }
      }
      if (wrap.__ceKbd) {
        wrap.__ceKbd = false;
        try { active.focus(); } catch (e) { /* node may be gone */ }
      }
    });
  }

  function init() {
    initAccents();
    initCtaPriceSuffix();
    initStickyPromoGuard();
    initReveals();
    initHeroStagger();
    injectSticker();
    initCountUp();
    initProofCycle();
    /* client-rendered PDP labels + tier cards: retry briefly + follow
       machinery events (the selector re-renders cards on brand switch) */
    [600, 1500, 3200].forEach(function (ms) {
      setTimeout(function () {
        initStepNums(); initTierChips(); initTierRail(); initFinishSwitch(); initTierRestore();
        decorateFreePricing(); decorateNonCaseOffer();
      }, ms);
    });
    document.addEventListener('ce:state-change', function () {
      initStepNums(); initTierChips(); initTierRail(); initFinishSwitch(); initTierRestore();
      restoreTierState(); decorateFreePricing(); decorateNonCaseOffer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: sections re-render — reveal everything, re-run idempotent bits */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.e-reveal-auto, .k-reveal, .e-reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
    initAccents();
  });
})();
